// Location pages: routes render a service template with suburb-specific
// H1 and intro paragraph. /aircons-install* routes use the installation
// template (see isInstallerRoute in seo-config.js); everything else uses
// the aircon-repairs template.
//
// Fields per route:
//   suburb    — used in <title>/meta description (full name incl. parent suburb)
//   rest      — second half of the H1 after the highlighted "Aircon repairs"
//   paragraph — intro text under the H1
//   accent    — highlighted H1 prefix (defaults to 'Aircon repairs')
//   meta      — full title/description override (service pages)

export const LOCATION_PAGES = {
  // Existing Search Console URLs
  '/aircons-installer-kuils-river': {
    suburb: 'Kuils River',
    rest: 'in Kuils River',
    paragraph: "Replacing an old unit or fitting aircon for the first time? Tell us about your Kuils River space and we will size and quote an installation that fits.",
  },
  '/aircons-installation-melkbosstrand': {
    suburb: 'Melkbosstrand',
    rest: 'in Melkbosstrand',
    paragraph: 'Salt air and summer heat put extra load on a coastal unit. Tell us about your Melkbosstrand property and we will recommend a properly sized installation.',
  },
  '/aircons-installer-fish-hoek': {
    suburb: 'Fish Hoek',
    rest: 'in Fish Hoek',
    paragraph: 'From a single bedroom split to a full-house setup, describe your Fish Hoek home and we will plan and price an installation that fits.',
  },
  '/aircons-installer-durbanville': {
    suburb: 'Durbanville',
    rest: 'in Durbanville',
    paragraph: 'Getting a new aircon installed or swapping out an ageing unit? Share your Durbanville property details and we will size and quote the job.',
  },
  '/aircons-installation-milnerton': {
    suburb: 'Milnerton',
    rest: 'in Milnerton',
    paragraph: 'Wind off the lagoon and open-plan living need the right capacity. Tell us about your Milnerton space for a properly sized installation quote.',
  },
  '/aircons-installations-pinelands': {
    suburb: 'Pinelands',
    rest: 'in Pinelands',
    paragraph: 'Older Pinelands homes often need careful placement for indoor and outdoor units. Describe your layout and we will quote a new installation.',
  },
  '/aircons-installer-grassy-park': {
    suburb: 'Grassy Park',
    rest: 'in Grassy Park',
    paragraph: 'A correctly sized unit cools faster and costs less to run. Tell us about your Grassy Park rooms and we will recommend an installation to fit.',
  },
  '/aircons-installer-lansdowne': {
    suburb: 'Lansdowne',
    rest: 'in Lansdowne',
    paragraph: 'Planning aircon for a bedroom, lounge or small business in Lansdowne? Share the space details and get an installation sized and priced properly.',
  },
  '/aircons-installations-strandfontein': {
    suburb: 'Strandfontein',
    rest: 'in Strandfontein',
    paragraph: 'Coastal conditions are hard on outdoor units. Tell us about your Strandfontein property and we will quote an installation built to last.',
  },
  '/aircons-installer-retreat': {
    suburb: 'Retreat',
    rest: 'in Retreat',
    paragraph: 'Whether it is one room or the whole house in Retreat, describe the space and we will plan an aircon installation and quote it up front.',
  },
  '/aircons-installer-table-view': {
    suburb: 'Table View',
    rest: 'in Table View',
    paragraph: 'West Coast summers call for properly sized cooling. Share your Table View property details and we will recommend and price an installation.',
  },
  '/aircons-installer-melkbosstrand': {
    suburb: 'Melkbosstrand',
    rest: 'in Melkbosstrand',
    paragraph: 'New build or retrofit in Melkbosstrand? Tell us about the rooms you want cooled and we will size and quote an installation for the property.',
  },
  '/aircons-installer-simon-s-town': {
    suburb: "Simon's Town",
    rest: "in Simon's Town",
    paragraph: "From hillside homes to harbour-side offices in Simon's Town, describe your space and we will plan and price a new aircon installation.",
  },
  '/aircons-installation-wynberg': {
    suburb: 'Wynberg',
    rest: 'in Wynberg',
    paragraph: 'An old unit that never quite coped is worth replacing properly. Tell us about your Wynberg property and we will quote a correctly sized installation.',
  },
  '/aircons-installations-kommetjie': {
    suburb: 'Kommetjie',
    rest: 'in Kommetjie',
    paragraph: 'Salty air shortens the life of undersized equipment. Describe your Kommetjie home and we will recommend and price an installation to suit.',
  },
  '/aircons-installer-kensington': {
    suburb: 'Kensington',
    rest: 'in Kensington',
    paragraph: 'A new installation sized to the room beats an oversized unit that short-cycles. Share your Kensington space details for a proper quote.',
  },
  '/refrigeration-repairs': {
    suburb: null,
    accent: 'Refrigeration repairs',
    rest: 'in Cape Town',
    paragraph: "Fridge or refrigeration unit not holding its temperature? Tell us the equipment type and what's happening, then discuss a repair assessment in Cape Town.",
    meta: {
      title: 'Refrigeration Repairs in Cape Town | Aircons Cape Town',
      description: "Fridge or refrigeration unit not holding its temperature? Tell us the equipment type and what's happening, then discuss a repair assessment in Cape Town.",
    },
  },
  '/aircons-installations-camps-bay': {
    suburb: 'Camps Bay',
    rest: 'in Camps Bay',
    paragraph: 'Sea-facing homes in Camps Bay need corrosion-aware placement and correct sizing. Tell us about the property and we will quote an installation.',
  },
  '/aircons-installations-meadowridge': {
    suburb: 'Meadowridge',
    rest: 'in Meadowridge',
    paragraph: 'Fitting aircon to a family home in Meadowridge? Describe the rooms and we will recommend and price an installation that fits the space.',
  },
  '/aircons-installer-ridgewood': {
    suburb: 'Ridgewood',
    rest: 'in Ridgewood',
    paragraph: 'Planning cooling for a Ridgewood home or office? Share the layout and we will size and quote a new aircon installation before we start.',
  },
  '/aircons-installations-platterkloof': {
    suburb: 'Plattekloof',
    rest: 'in Plattekloof',
    paragraph: 'Whether it is a Plattekloof townhouse or a double-storey home, describe the space and we will plan and price a properly sized installation.',
  },
  '/aircons-installation-monte-vista': {
    suburb: 'Monte Vista',
    rest: 'in Monte Vista',
    paragraph: 'A correctly sized aircon installs once and runs cheaply for years. Tell us about your Monte Vista property and we will quote a new installation.',
  },

  // Atlantic Seaboard
  '/aircon-repair-alphen-estate-constantia': {
    suburb: 'Alphen Estate, Constantia',
    rest: 'in Alphen Estate',
    paragraph: "Aircon not cooling as it should? Tell us what's happening with your unit in Alphen Estate, Constantia, and arrange a repair assessment.",
  },
  '/aircon-repair-avignon-security-estate-hout-bay': {
    suburb: 'Avignon Estate, Hout Bay',
    rest: 'in Avignon Estate',
    paragraph: 'A leaking or unresponsive aircon can interrupt your day. Get in touch about your unit in Avignon Estate, Hout Bay, to discuss an assessment.',
  },
  '/aircon-repair-bakoven': {
    suburb: 'Bakoven',
    rest: 'in Bakoven',
    paragraph: "If your aircon runs but the room stays warm, let us know. We'll discuss the problem and arrange a visit in Bakoven.",
  },
  '/aircon-repair-bantry-bay': {
    suburb: 'Bantry Bay',
    rest: 'in Bantry Bay',
    paragraph: 'Has your aircon become noisy, started leaking, or stopped working? Describe the issue with your Bantry Bay unit when you contact us.',
  },
  '/aircon-repair-bergendal-security-estate-hout-bay': {
    suburb: 'Bergendal Estate, Hout Bay',
    rest: 'in Bergendal Estate',
    paragraph: 'Tell us what has changed with your aircon, from weaker cooling to unexpected shutdowns. Arrange an assessment in Bergendal Estate, Hout Bay.',
  },
  '/aircon-repair-clifton': {
    suburb: 'Clifton',
    rest: 'in Clifton',
    paragraph: 'If your aircon is making the room less comfortable rather than more, get in touch about a repair visit at your Clifton property.',
  },
  '/aircon-repair-fresnaye': {
    suburb: 'Fresnaye',
    rest: 'in Fresnaye',
    paragraph: "An aircon that starts but doesn't cool needs a closer look. Get in touch about your Fresnaye unit and explain what happens when it runs.",
  },
  '/aircon-repair-green-point': {
    suburb: 'Green Point',
    rest: 'in Green Point',
    paragraph: "Need someone to look at an aircon that isn't behaving normally? Describe the issue and discuss a repair visit in Green Point.",
  },
  '/aircon-repair-hanging-meadows-security-estate-hout-bay': {
    suburb: 'Hanging Meadows, Hout Bay',
    rest: 'in Hanging Meadows',
    paragraph: "Contact us about an aircon fault at your Hanging Meadows property in Hout Bay. Include the unit's make and any message on the display.",
  },
  '/aircon-repair-hout-bay': {
    suburb: 'Hout Bay',
    rest: 'in Hout Bay',
    paragraph: 'Aircon stopped working when you need it? Get in touch with the details of the fault and ask about an assessment in Hout Bay.',
  },
  '/aircon-repair-kenrock-security-estate-hout-bay': {
    suburb: 'KenRock Estate, Hout Bay',
    rest: 'in KenRock Estate',
    paragraph: "Arrange a closer look at an aircon that's no longer working properly. Contact us about your unit in KenRock Estate, Hout Bay.",
  },
  '/aircon-repair-llandudno': {
    suburb: 'Llandudno',
    rest: 'in Llandudno',
    paragraph: "An aircon shouldn't leave you guessing whether it will work today. Tell us about the fault and arrange an assessment in Llandudno.",
  },
  '/aircon-repair-mouille-point': {
    suburb: 'Mouille Point',
    rest: 'in Mouille Point',
    paragraph: "If your aircon has developed a noise you haven't heard before, tell us when it occurs. Arrange an assessment in Mouille Point.",
  },
  '/aircon-repair-ruyteplaats-security-estate-hout-bay': {
    suburb: 'Ruyteplaats, Hout Bay',
    rest: 'in Ruyteplaats',
    paragraph: "Tell us about the aircon problem at your Ruyteplaats property in Hout Bay. We'll discuss an assessment and the details needed for the visit.",
  },
  '/aircon-repair-sea-point': {
    suburb: 'Sea Point',
    rest: 'in Sea Point',
    paragraph: 'Poor cooling or an unexpected shutdown can disrupt a busy day. Contact us about your aircon and discuss a repair visit in Sea Point.',
  },
  '/aircon-repair-stoneybrook-security-estate-hout-bay': {
    suburb: 'Stoneybrook, Hout Bay',
    rest: 'in Stoneybrook',
    paragraph: 'If your aircon is no longer reliable, tell us when the trouble occurs. Ask about an assessment in Stoneybrook, Hout Bay.',
  },
  '/aircon-repair-three-anchor-bay': {
    suburb: 'Three Anchor Bay',
    rest: 'in Three Anchor Bay',
    paragraph: 'Get your aircon looked at when its performance stops matching its settings. Tell us about the problem at your Three Anchor Bay property.',
  },
  '/aircon-repair-tierboskloof-security-estate-hout-bay': {
    suburb: 'Tierboskloof, Hout Bay',
    rest: 'in Tierboskloof',
    paragraph: "Need an aircon assessment at your Tierboskloof property in Hout Bay? Share what's happening with the unit and discuss arrangements for a visit.",
  },

  // City Bowl / CBD
  '/aircon-repair-bo-kaap': {
    suburb: 'Bo-Kaap',
    rest: 'in Bo-Kaap',
    paragraph: "Need help with an aircon that won't start or won't stay on? Contact us to discuss the fault and a visit in Bo-Kaap.",
  },
  '/aircon-repair-devils-peak-estate': {
    suburb: "Devil's Peak Estate",
    rest: "in Devil's Peak Estate",
    paragraph: 'Is your aircon running longer without making the room comfortable? Tell us about the problem and arrange a visit in Devil\u2019s Peak Estate.',
  },
  '/aircon-repair-gardens': {
    suburb: 'Gardens',
    rest: 'in Gardens',
    paragraph: "Trouble getting your aircon to switch on, cool, or respond to the controls? Contact us to arrange an assessment in Gardens.",
  },
  '/aircon-repair-higgovale': {
    suburb: 'Higgovale',
    rest: 'in Higgovale',
    paragraph: "If you're repeatedly turning your aircon off and on to get it working, tell us. Arrange an assessment at your Higgovale property.",
  },
  '/aircon-repair-oranjezicht': {
    suburb: 'Oranjezicht',
    rest: 'in Oranjezicht',
    paragraph: 'Noticed water beneath the unit or a change in how it runs? Get in touch about an aircon assessment at your Oranjezicht property.',
  },
  '/aircon-repair-tamboerskloof': {
    suburb: 'Tamboerskloof',
    rest: 'in Tamboerskloof',
    paragraph: 'Has your aircon stopped, started dripping, or become unusually loud? Describe the change when you contact us about a visit in Tamboerskloof.',
  },
  '/aircon-repair-v-a-waterfront': {
    suburb: 'V&A Waterfront',
    rest: 'at the V&A Waterfront',
    paragraph: 'An aircon problem can interrupt your home or working day. Tell us what needs attention at your V&A Waterfront property and discuss an assessment.',
  },
  '/aircon-repair-vredehoek': {
    suburb: 'Vredehoek',
    rest: 'in Vredehoek',
    paragraph: 'When your aircon behaves differently from one day to the next, explain the pattern. Discuss a repair assessment at your Vredehoek property.',
  },

  // Southern Suburbs / Constantia Valley
  '/aircon-repair-bergvliet': {
    suburb: 'Bergvliet',
    rest: 'in Bergvliet',
    paragraph: "You shouldn't have to keep adjusting the remote to get comfortable. Contact us about an aircon that isn't working properly in Bergvliet.",
  },
  '/aircon-repair-bishopscourt': {
    suburb: 'Bishopscourt',
    rest: 'in Bishopscourt',
    paragraph: 'Whether one unit is struggling or your aircon has stopped altogether, get in touch to arrange an assessment at your Bishopscourt property.',
  },
  '/aircon-repair-claremont': {
    suburb: 'Claremont',
    rest: 'in Claremont',
    paragraph: "Don't know why your aircon has stopped cooling? Start by telling us what you've noticed, then arrange an assessment in Claremont.",
  },
  '/aircon-repair-constantia': {
    suburb: 'Constantia',
    rest: 'in Constantia',
    paragraph: "Weak cooling, water indoors, or a unit that won't start — tell us what's wrong and arrange an aircon assessment in Constantia.",
  },
  '/aircon-repair-dreyersdal-bergvliet-area': {
    suburb: 'Dreyersdal, Bergvliet',
    rest: 'in Dreyersdal',
    paragraph: "You don't need to know the technical name for the fault. Describe what your aircon is doing at your Dreyersdal property in Bergvliet.",
  },
  '/aircon-repair-high-constantia-security-estate': {
    suburb: 'High Constantia',
    rest: 'in High Constantia',
    paragraph: 'Let us know what your aircon does when you switch it on. Discuss the symptoms and arrange a repair assessment in High Constantia.',
  },
  '/aircon-repair-kenilworth': {
    suburb: 'Kenilworth',
    rest: 'in Kenilworth',
    paragraph: 'You set the temperature, but the room never seems to reach it. Tell us about your aircon and arrange a visit in Kenilworth.',
  },
  '/aircon-repair-kirstenhof': {
    suburb: 'Kirstenhof',
    rest: 'in Kirstenhof',
    paragraph: 'Is your aircon switching off unexpectedly or struggling to start? Describe what happens and discuss an assessment at your Kirstenhof property.',
  },
  '/aircon-repair-marina-da-gama-muizenberg': {
    suburb: 'Marina da Gama, Muizenberg',
    rest: 'in Marina da Gama',
    paragraph: 'Get help with an aircon that drips, stops, or struggles to cool. Discuss an assessment at your Marina da Gama property in Muizenberg.',
  },
  '/aircon-repair-newlands': {
    suburb: 'Newlands',
    rest: 'in Newlands',
    paragraph: 'A unit can be running without keeping you comfortable. Tell us how your aircon is performing and arrange an assessment in Newlands.',
  },
  '/aircon-repair-rondebosch': {
    suburb: 'Rondebosch',
    rest: 'in Rondebosch',
    paragraph: 'Get help making sense of an aircon fault, whether it started suddenly or developed over time. Discuss an assessment in Rondebosch.',
  },
  '/aircon-repair-rondebosch-oval-estate': {
    suburb: 'Rondebosch Oval',
    rest: 'at Rondebosch Oval',
    paragraph: "Have a unit that isn't cooling your home at Rondebosch Oval? Share the symptoms and arrange a suitable time for an assessment.",
  },
  '/aircon-repair-silverhurst-security-estate-constantia': {
    suburb: 'Silverhurst, Constantia',
    rest: 'in Silverhurst',
    paragraph: 'Arrange an assessment for an aircon that no longer runs as it should. Tell us about your unit in Silverhurst, Constantia.',
  },
  '/aircon-repair-silvertree-estate-tokai': {
    suburb: 'Silvertree Estate, Tokai',
    rest: 'in Silvertree Estate',
    paragraph: 'Having to work around an aircon fault at home? Describe the issue and discuss a visit to your Silvertree Estate property in Tokai.',
  },
  '/aircon-repair-steenberg': {
    suburb: 'Steenberg',
    rest: 'in Steenberg',
    paragraph: "You don't have to diagnose the fault before getting in touch. Tell us what's happening and arrange an aircon assessment in Steenberg.",
  },
  '/aircon-repair-stonehurst-security-estate-tokai': {
    suburb: 'Stonehurst, Tokai',
    rest: 'in Stonehurst',
    paragraph: 'Contact us about an aircon that needs attention at your Stonehurst property in Tokai. Describe the fault and discuss a suitable assessment time.',
  },
  '/aircon-repair-tokai': {
    suburb: 'Tokai',
    rest: 'in Tokai',
    paragraph: "If you've noticed less cooling, more noise, or unexpected stops, get in touch. Arrange an assessment for your aircon in Tokai.",
  },
  '/aircon-repair-zwaanswyk': {
    suburb: 'Zwaanswyk',
    rest: 'in Zwaanswyk',
    paragraph: "Tell us what's changed with your aircon and when you first noticed it. Arrange a repair assessment at your Zwaanswyk property.",
  },

  // Peninsula / False Bay
  '/aircon-repair-capri-village-fish-hoek': {
    suburb: 'Capri Village, Fish Hoek',
    rest: 'in Capri Village',
    paragraph: 'If your aircon has started playing up, tell us when it happens and what you notice. Arrange a visit in Capri Village, Fish Hoek.',
  },
  '/aircon-repair-clovelly': {
    suburb: 'Clovelly',
    rest: 'in Clovelly',
    paragraph: 'Does your aircon work for a while and then stop? Explain the pattern when you contact us about an assessment in Clovelly.',
  },
  '/aircon-repair-de-goede-hoop-security-estate-noordhoek': {
    suburb: 'De Goede Hoop, Noordhoek',
    rest: 'in De Goede Hoop',
    paragraph: 'Have an aircon problem at your De Goede Hoop property in Noordhoek? Share the symptoms and discuss a suitable time for an assessment.',
  },
  '/aircon-repair-glencairn': {
    suburb: 'Glencairn',
    rest: 'in Glencairn',
    paragraph: 'Tell us whether the problem happens every time or only now and then. We can discuss a repair assessment for your aircon in Glencairn.',
  },
  '/aircon-repair-kalk-bay': {
    suburb: 'Kalk Bay',
    rest: 'in Kalk Bay',
    paragraph: 'From unexpected drips to poor airflow, explain what has changed with your aircon. Contact us about a repair assessment in Kalk Bay.',
  },
  '/aircon-repair-lake-michelle-security-lifestyle-estate-noordhoek': {
    suburb: 'Lake Michelle, Noordhoek',
    rest: 'in Lake Michelle',
    paragraph: 'If your aircon has become unreliable, explain when the trouble started. Get in touch about a repair assessment in Lake Michelle, Noordhoek.',
  },
  '/aircon-repair-muizenberg': {
    suburb: 'Muizenberg',
    rest: 'in Muizenberg',
    paragraph: 'Need your aircon checked before deciding what to do next? Explain the fault and contact us about a repair visit in Muizenberg.',
  },
  '/aircon-repair-noordhoek': {
    suburb: 'Noordhoek',
    rest: 'in Noordhoek',
    paragraph: "If your aircon has stopped responding or isn't cooling properly, start with a conversation. Share the details and discuss a visit in Noordhoek.",
  },
  '/aircon-repair-plumstead': {
    suburb: 'Plumstead',
    rest: 'in Plumstead',
    paragraph: "If changing the settings hasn't solved the problem, arrange a closer look. Tell us what your aircon is doing in Plumstead.",
  },
  '/aircon-repair-scarborough': {
    suburb: 'Scarborough',
    rest: 'in Scarborough',
    paragraph: "If your aircon has gone from dependable to unpredictable, get in touch. Explain what's changed and ask about an assessment in Scarborough.",
  },
  '/aircon-repair-st-james': {
    suburb: 'St James',
    rest: 'in St James',
    paragraph: "If the aircon sounds different or isn't cooling evenly, let us know. Discuss the symptoms and arrange an assessment in St James.",
  },

  // Century City
  '/aircon-repair-century-city': {
    suburb: 'Century City',
    rest: 'in Century City',
    paragraph: "A working aircon matters when you're at home or trying to get through the workday. Discuss a repair assessment in Century City.",
  },
  '/aircon-repair-island-club-century-city': {
    suburb: 'Island Club, Century City',
    rest: 'at Island Club',
    paragraph: 'Have an aircon that needs attention at Island Club, Century City? Tell us about the problem and any access arrangements when discussing your booking.',
  },
  '/aircon-repair-knightsbridge-century-city': {
    suburb: 'Knightsbridge, Century City',
    rest: 'at Knightsbridge',
    paragraph: 'For an aircon problem at Knightsbridge, Century City, share the symptoms and unit details. Let us know about building access when arranging the visit.',
  },

  // Northern Suburbs
  '/aircon-repair-big-bay': {
    suburb: 'Big Bay',
    rest: 'in Big Bay',
    paragraph: "Aircon blowing without much cooling? Share the symptoms and your unit's make so we can discuss a repair visit in Big Bay.",
  },
  '/aircon-repair-bloubergstrand': {
    suburb: 'Bloubergstrand',
    rest: 'in Bloubergstrand',
    paragraph: 'A change in noise, airflow, or cooling is worth explaining when you book. Tell us what your Bloubergstrand aircon is doing.',
  },
  '/aircon-repair-burgundy-estate': {
    suburb: 'Burgundy Estate',
    rest: 'in Burgundy Estate',
    paragraph: 'Get help with an aircon that no longer keeps the room comfortable. Describe the problem and arrange an assessment in Burgundy Estate.',
  },
  '/aircon-repair-clara-anna-fontein-durbanville': {
    suburb: 'Clara Anna Fontein, Durbanville',
    rest: 'in Clara Anna Fontein',
    paragraph: "From an aircon that won't respond to one that cools poorly, tell us what needs attention at your Clara Anna Fontein property in Durbanville.",
  },
  '/aircon-repair-edgemead': {
    suburb: 'Edgemead',
    rest: 'in Edgemead',
    paragraph: 'Get your aircon problem looked at rather than guessing what needs replacing. Contact us to discuss an assessment at your Edgemead property.',
  },
  '/aircon-repair-graanendal-lifestyle-estate-durbanville': {
    suburb: 'Graanendal, Durbanville',
    rest: 'in Graanendal',
    paragraph: "A new noise or a drop in cooling can be difficult to explain. Tell us what you've noticed at your Graanendal property in Durbanville.",
  },
  '/aircon-repair-loevenstein': {
    suburb: 'Loevenstein',
    rest: 'in Loevenstein',
    paragraph: "Has the airflow weakened, or does the air no longer feel cool? Contact us to discuss what's happening with your Loevenstein aircon.",
  },
  '/aircon-repair-parklands': {
    suburb: 'Parklands',
    rest: 'in Parklands',
    paragraph: 'An aircon that keeps stopping can make the room difficult to use comfortably. Contact us about the problem at your Parklands property.',
  },
  '/aircon-repair-sonstraal-durbanville': {
    suburb: 'Sonstraal, Durbanville',
    rest: 'in Sonstraal',
    paragraph: 'Has your aircon started taking much longer to cool the room? Get in touch about an assessment at your Sonstraal property in Durbanville.',
  },
  '/aircon-repair-sonstraal-heights-durbanville': {
    suburb: 'Sonstraal Heights, Durbanville',
    rest: 'in Sonstraal Heights',
    paragraph: 'Explain what your aircon does — and what it no longer does. Contact us to discuss a repair assessment in Sonstraal Heights, Durbanville.',
  },
  '/aircon-repair-sunningdale': {
    suburb: 'Sunningdale',
    rest: 'in Sunningdale',
    paragraph: 'A room that stays warm despite the aircon being on needs a closer look. Arrange an assessment at your Sunningdale property.',
  },
  '/aircon-repair-welgemoed': {
    suburb: 'Welgemoed',
    rest: 'in Welgemoed',
    paragraph: "Is your aircon taking longer to cool or cutting out before you're comfortable? Contact us about an assessment at your Welgemoed property.",
  },

  // Helderberg
  '/aircon-repair-de-zalze-golf-estate-somerset-west-stellenbosch-border': {
    suburb: 'De Zalze Golf Estate',
    rest: 'in De Zalze Golf Estate',
    paragraph: 'When your aircon no longer works the way it used to, start with an assessment. Contact us about your unit at De Zalze Golf Estate.',
  },
  '/aircon-repair-erinvale-golf-estate-somerset-west': {
    suburb: 'Erinvale Golf Estate, Somerset West',
    rest: 'in Erinvale Golf Estate',
    paragraph: "Arrange an assessment for an aircon that's leaking, noisy, or not cooling at your Erinvale Golf Estate property in Somerset West.",
  },
  '/aircon-repair-gordons-bay': {
    suburb: "Gordon's Bay",
    rest: "in Gordon's Bay",
    paragraph: 'If the aircon is on but the room still feels uncomfortable, get in touch. Arrange a visit to assess your unit in Gordon\u2019s Bay.',
  },
  '/aircon-repair-somerset-west': {
    suburb: 'Somerset West',
    rest: 'in Somerset West',
    paragraph: "Whether the unit won't start or the cooling has gradually weakened, tell us what you've noticed. Arrange an aircon assessment in Somerset West.",
  },

  // Cape Winelands
  '/aircon-repair-franschhoek': {
    suburb: 'Franschhoek',
    rest: 'in Franschhoek',
    paragraph: "Has your aircon stopped keeping up with the temperature you set? Tell us what's changed and ask about a repair visit in Franschhoek.",
  },
  '/aircon-repair-paarl': {
    suburb: 'Paarl',
    rest: 'in Paarl',
    paragraph: 'Tell us what happens when you turn your aircon on, including any lights or messages. Ask about a repair assessment in Paarl.',
  },
  '/aircon-repair-stellenbosch': {
    suburb: 'Stellenbosch',
    rest: 'in Stellenbosch',
    paragraph: 'Aircon running through its settings without much result? Share the unit details and discuss a repair assessment at your Stellenbosch property.',
  },
  '/aircon-repair-val-de-vie-estate-paarl': {
    suburb: 'Val de Vie Estate, Paarl',
    rest: 'in Val de Vie Estate',
    paragraph: "Arrange a visit to assess an aircon that isn't working properly. Contact us about your unit at Val de Vie Estate, Paarl.",
  },
};

// Per-page Diagnosis section content (Layout19): an H2, a paragraph, and a
// three-step ordered list describing the assess-quote-approve workflow.
export const LOCATION_DIAGNOSIS = {
  // Existing Search Console URLs
  '/aircons-installer-kuils-river': {
    heading: 'Check the cause before agreeing to the fix',
    paragraph: "A unit that won't start, won't cool, or keeps stopping needs an assessment. We inspect your Kuils River aircon and explain what we find. You can review the proposed work and quoted cost before authorising the repair.",
    steps: [
      'Assess the reported fault',
      'Explain what the repair involves',
      'Get your approval before proceeding',
    ],
  },
  '/aircons-installation-melkbosstrand': {
    heading: 'Check the existing unit before deciding',
    paragraph: 'If your current aircon has stopped cooling properly, start by finding out what needs attention. We assess your Melkbosstrand unit, explain the findings, and discuss the proposed repair before you decide whether to authorise the work.',
    steps: [
      "Review the existing unit's problem",
      'Explain the assessment findings',
      'Quote for any proposed repair',
    ],
  },
  '/aircons-installer-fish-hoek': {
    heading: 'Compare what it did with what it does now',
    paragraph: 'You know when your aircon stops performing the way you expect. Tell us what has changed at your Fish Hoek property. We assess the unit, explain what we find, and discuss the repair proposal before you approve the work.',
    steps: [
      'Discuss previous and current performance',
      'Check the reported change',
      'Review the proposed repair and quote',
    ],
  },
  '/aircons-installer-durbanville': {
    heading: 'Different faults need different answers',
    paragraph: "A unit that won't turn on needs its own assessment, just as weaker cooling does. Tell us which problem affects your Durbanville aircon. We check the unit and explain the proposed work rather than offering an assumed fix.",
    steps: [
      "Establish the problem you're experiencing",
      'Assess the affected unit',
      'Explain the findings and proposed cost',
    ],
  },
  '/aircons-installation-milnerton': {
    heading: "Airflow alone doesn't explain the problem",
    paragraph: "You can hear the aircon running, but the room still isn't comfortable. Tell us what happens at your Milnerton property. We assess the unit's operation and explain the proposed work rather than assuming it needs a particular part.",
    steps: [
      'Discuss the cooling complaint',
      'Assess before recommending a remedy',
      'Explain the work and quoted price',
    ],
  },
  '/aircons-installations-pinelands': {
    heading: 'An unclear symptom still gives us a starting point',
    paragraph: "You may notice a sound, a drip, or simply less cooling without knowing why. Describe it when booking in Pinelands. We assess the aircon and explain what we find before discussing any proposed repair.",
    steps: [
      "Describe what you've noticed",
      'Have the unit assessed',
      'Review the findings and repair proposal',
    ],
  },
  '/aircons-installer-grassy-park': {
    heading: 'A simple description is enough to begin',
    paragraph: "You don't need to work out the cause before contacting us. Explain what happens when you switch on your Grassy Park aircon. We assess the problem and talk you through the findings and any proposed repair.",
    steps: [
      'Tell us what the unit does',
      'Get the problem assessed',
      'Understand the work before approving it',
    ],
  },
  '/aircons-installer-lansdowne': {
    heading: "Constant adjustments aren't the answer",
    paragraph: "If you're repeatedly changing settings to keep the room comfortable, explain what happens each time. We assess your Lansdowne aircon and discuss the findings, including any proposed repair and its cost, before work begins.",
    steps: [
      'Review the adjustments and symptoms',
      'Check how the unit responds',
      'Discuss the proposed work for approval',
    ],
  },
  '/aircons-installations-strandfontein': {
    heading: 'Stop guessing why the room stays warm',
    paragraph: 'When the aircon is running but cooling disappoints, a check is the next step. We assess the unit at your Strandfontein property and explain any proposed repair, including its cost, before you decide whether to go ahead.',
    steps: [
      'Check the reported cooling fault',
      'Explain the repair recommendation',
      'Confirm the quote before work begins',
    ],
  },
  '/aircons-installer-retreat': {
    heading: 'Check why the unit no longer responds',
    paragraph: 'Does the aircon ignore commands, start briefly, or fail to switch on? Describe the response when booking in Retreat. We assess the unit and explain the findings before discussing any proposed repair and the cost involved.',
    steps: [
      'Review how the unit responds',
      'Assess the reported fault',
      'Quote for the proposed repair',
    ],
  },
  '/aircons-installer-table-view': {
    heading: "Understand why it isn't reaching the setting",
    paragraph: 'If your aircon keeps running without making the room comfortable, explain how its performance has changed. We assess the Table View unit and discuss the findings, proposed work, and cost before you authorise any repair.',
    steps: [
      'Review the cooling complaint',
      "Check the unit's performance",
      'Explain the repair before approval',
    ],
  },
  '/aircons-installer-melkbosstrand': {
    heading: 'Get the recurring problem assessed',
    paragraph: 'If your aircon keeps stopping or cooling poorly, tell us whether the symptoms follow a pattern. We assess the Melkbosstrand unit and explain what the checks establish, including any further investigation needed before a repair can be recommended.',
    steps: [
      'Discuss the recurring symptoms',
      'Assess what can be established',
      'Explain any repair or further checks',
    ],
  },
  '/aircons-installer-simon-s-town': {
    heading: 'Check the change before recommending work',
    paragraph: "A new sound, a leak, or a complete stop each needs a closer look. Describe the issue with your Simon's Town aircon. We assess the unit and explain the repair proposal before you decide whether to proceed.",
    steps: [
      'Identify the reported change',
      'Assess before recommending a repair',
      'Agree on the quoted work first',
    ],
  },
  '/aircons-installation-wynberg': {
    heading: 'A clear repair proposal starts with a check',
    paragraph: 'If your aircon keeps letting you down, find out what the assessment shows before committing to work. We examine your Wynberg unit and explain the findings, proposed repair, and quoted cost so you can review the recommendation.',
    steps: [
      'Examine the affected aircon',
      'Explain the repair recommendation',
      'Review the quote before starting',
    ],
  },
  '/aircons-installations-kommetjie': {
    heading: 'Work out what the unit needs next',
    paragraph: 'Whether the aircon has stopped altogether or become unreliable, describe what happens when you use it. We assess your Kommetjie unit and discuss the findings, including whether a repair or further investigation is proposed.',
    steps: [
      'Establish how the problem appears',
      "Assess the unit's operation",
      'Explain the next step for approval',
    ],
  },
  '/aircons-installer-kensington': {
    heading: 'New noises and drips need checking',
    paragraph: "If something sounds or looks different, tell us when it started. We assess your Kensington aircon and explain what the checks show, so any repair recommendation comes with a reason and a quote you can review.",
    steps: [
      "Record the change you've noticed",
      'Assess the unit before proposing work',
      'Explain the recommendation and price',
    ],
  },
  '/refrigeration-repairs': {
    heading: "Find out why it isn't keeping cold",
    paragraph: "If your fridge or refrigeration unit isn't holding its temperature, tell us what equipment you have and what has changed. We assess the reported problem, explain the findings, and discuss the proposed repair before you approve the work.",
    steps: [
      'Identify the equipment and symptoms',
      'Assess the reported temperature problem',
      'Explain the repair and quote before starting',
    ],
  },
  '/aircons-installations-camps-bay': {
    heading: "Starting normally doesn't rule out a fault",
    paragraph: 'Your aircon may switch on as usual but cool less effectively than before. Tell us what has changed at your Camps Bay property. We assess the unit and explain any proposed work before you authorise a repair.',
    steps: [
      'Discuss the change after startup',
      "Check the unit's performance",
      'Explain the proposed repair and cost',
    ],
  },
  '/aircons-installations-meadowridge': {
    heading: 'Understand why the room no longer feels right',
    paragraph: 'If your aircon no longer keeps the room comfortable, tell us how its performance has changed. We assess the unit at your Meadowridge property and explain what the findings mean before recommending work and providing a quote.',
    steps: [
      'Review the performance change',
      'Assess the aircon',
      'Discuss the recommended work and cost',
    ],
  },
  '/aircons-installer-ridgewood': {
    heading: 'Find out why cooling has become a struggle',
    paragraph: "If the room takes longer to cool or never feels comfortable, tell us what you've noticed. We assess your Ridgewood aircon and explain the findings, giving you a clearer understanding of any repair being proposed.",
    steps: [
      'Discuss the cooling performance',
      "Examine the unit's operation",
      'Explain the proposed work and cost',
    ],
  },
  '/aircons-installations-platterkloof': {
    heading: 'Find out why the fault keeps returning',
    paragraph: 'If the aircon works for a while and then gives trouble again, explain the pattern. We assess your Plattekloof unit and discuss what can be established during the visit before proposing a repair or additional investigation.',
    steps: [
      'Review when the problem returns',
      'Assess the reported behaviour',
      'Explain the findings and next step',
    ],
  },
  '/aircons-installation-monte-vista': {
    heading: 'Check what happens after the controls respond',
    paragraph: "A responding display doesn't explain why the aircon isn't doing its job. Describe what happens next when booking your Monte Vista assessment. We inspect the reported problem and explain the repair proposal before you agree to proceed.",
    steps: [
      'Review the controls and unit response',
      'Assess the reported fault',
      'Obtain approval for the proposed work',
    ],
  },

  // Atlantic Seaboard
  '/aircon-repair-alphen-estate-constantia': {
    heading: 'Find the cause before choosing the repair',
    paragraph: "Poor cooling doesn't tell you which part needs attention. We assess the unit, explain what we find, and discuss the proposed repair. For your Alphen Estate booking, let us know whether the problem started suddenly or has become worse over time.",
    steps: [
      'Check how the unit is operating',
      'Explain the findings and repair cost',
      'Get approval before starting work',
    ],
  },
  '/aircon-repair-avignon-security-estate-hout-bay': {
    heading: "Know what's wrong before work begins",
    paragraph: "You shouldn't have to approve a repair without understanding the problem. We examine the aircon and explain what needs attention. When booking at Avignon Estate, describe what happens when you turn the unit on, including any lights or messages.",
    steps: [
      "Discuss the symptoms you've noticed",
      'Assess the unit and explain the fault',
      'Quote for the agreed repair',
    ],
  },
  '/aircon-repair-bakoven': {
    heading: "Running doesn't always mean cooling",
    paragraph: 'The aircon is on, but the room still feels warm. Rather than guessing what it needs, we check the unit and discuss the findings. Tell us how your Bakoven aircon has been performing and whether anything has recently changed.',
    steps: [
      'Review the cooling problem',
      'Check the unit before recommending work',
      'Explain the repair and its cost',
    ],
  },
  '/aircon-repair-bantry-bay': {
    heading: 'A clearer answer to an unfamiliar noise',
    paragraph: 'A noise can be difficult to describe over the phone. Tell us when you hear it — at startup, during operation, or when the unit stops. We assess your Bantry Bay aircon and explain the findings before recommending a repair.',
    steps: [
      'Listen to your description of the noise',
      "Examine the unit's operation",
      'Discuss the proposed work before proceeding',
    ],
  },
  '/aircon-repair-bergendal-security-estate-hout-bay': {
    heading: "Check what changed, then decide what's needed",
    paragraph: 'Perhaps the cooling has weakened, or the unit has started switching off. Explain what feels different about your Bergendal Estate aircon. We use that information alongside an inspection, then talk you through the repair proposal before work begins.',
    steps: [
      'Record when the problem occurs',
      'Inspect the unit and explain the findings',
      'Agree on the work and price first',
    ],
  },
  '/aircon-repair-clifton': {
    heading: 'Check the unit before replacing parts',
    paragraph: "It's reasonable to want an explanation before paying for replacement components. We assess your Clifton aircon and explain any proposed parts and work. You can review the quote and ask questions before authorising the repair.",
    steps: [
      'Examine the reported fault',
      'Explain any recommended replacement',
      'Get agreement on the quoted work',
    ],
  },
  '/aircon-repair-fresnaye': {
    heading: 'Switching on is only part of the story',
    paragraph: 'Your aircon may start normally but fail to do what you need. Describe its behaviour after startup when booking in Fresnaye. We check the reported issue and explain whether a repair or further investigation is proposed.',
    steps: [
      'Discuss what happens after startup',
      "Inspect the unit's operation",
      'Explain the next step and cost',
    ],
  },
  '/aircon-repair-green-point': {
    heading: 'Get the fault checked before committing',
    paragraph: 'You want the aircon working, but you also want to understand the bill. We assess the problem at your Green Point property and explain the proposed repair, giving you a chance to review the quote before agreeing.',
    steps: [
      'Check the reported problem',
      'Explain what the repair involves',
      'Confirm approval before proceeding',
    ],
  },
  '/aircon-repair-hanging-meadows-security-estate-hout-bay': {
    heading: 'Bring the symptoms, not a diagnosis',
    paragraph: "Share the make, any display message, and what your aircon is doing at Hanging Meadows. You don't need to decide which part is faulty. We carry out the assessment and explain the work being proposed.",
    steps: [
      'Collect the unit and symptom details',
      'Assess what needs attention',
      'Explain the quote before repairs',
    ],
  },
  '/aircon-repair-hout-bay': {
    heading: 'An assessment before an answer',
    paragraph: 'A description helps us understand the complaint, but the unit still needs checking. We assess your Hout Bay aircon, explain what we can establish, and discuss any proposed work before asking you to approve the repair.',
    steps: [
      'Hear what has gone wrong',
      'Check the unit in person',
      'Explain the findings and proposed cost',
    ],
  },
  '/aircon-repair-kenrock-security-estate-hout-bay': {
    heading: "Know what needs attention—and why",
    paragraph: 'An explanation matters just as much as a repair recommendation. We assess your KenRock Estate aircon and discuss what we find, including the reason for any proposed work. You review the quote before deciding to proceed.',
    steps: [
      "Assess the aircon's operation",
      'Explain the recommendation',
      'Get your approval for the work',
    ],
  },
  '/aircon-repair-llandudno': {
    heading: "Don't plan around an unexplained fault",
    paragraph: 'If using the aircon has become unpredictable, arrange an assessment rather than working around the problem. We examine your Llandudno unit, explain the findings, and discuss the proposed repair so you can decide with the relevant information.',
    steps: [
      'Describe the unreliable behaviour',
      'Have the fault assessed',
      'Consider the repair proposal',
    ],
  },
  '/aircon-repair-mouille-point': {
    heading: 'Explain the noise. Let us investigate.',
    paragraph: 'Is the sound constant, occasional, or only there when the unit starts? Tell us what you hear from your Mouille Point aircon. We examine its operation and explain the findings before recommending any repair work.',
    steps: [
      'Note when the noise occurs',
      'Assess the unit during operation',
      'Discuss any recommended repair',
    ],
  },
  '/aircon-repair-ruyteplaats-security-estate-hout-bay': {
    heading: 'Know what the assessment has established',
    paragraph: 'After checking your Ruyteplaats aircon, we explain what we have found and whether anything needs further investigation. You can review the proposed next step and its cost before deciding what work to authorise at your property.',
    steps: [
      'Check the reported fault',
      'Explain findings and any remaining questions',
      'Discuss the next step before proceeding',
    ],
  },
  '/aircon-repair-sea-point': {
    heading: 'Understand the fault before approving the bill',
    paragraph: "Getting the room comfortable matters, but so does knowing what you're paying for. We assess your Sea Point aircon, explain the proposed repair, and provide a quote before asking you to authorise the work.",
    steps: [
      'Check what needs attention',
      'Explain the repair and price',
      'Confirm your approval before starting',
    ],
  },
  '/aircon-repair-stoneybrook-security-estate-hout-bay': {
    heading: 'An intermittent problem needs its history',
    paragraph: 'Tell us when the fault appears and whether anything seems to bring it on. We consider that history when assessing your Stoneybrook aircon and explain what can be established, including any need for further investigation.',
    steps: [
      'Discuss when the problem occurs',
      'Assess the reported behaviour',
      'Explain findings and any further checks',
    ],
  },
  '/aircon-repair-three-anchor-bay': {
    heading: 'Check why performance no longer matches the setting',
    paragraph: "If the aircon's settings look right but the room feels wrong, an assessment can establish what needs attention. We inspect your Three Anchor Bay unit and discuss the findings before you decide whether to approve the proposed repair.",
    steps: [
      'Review the performance problem',
      "Assess the aircon's operation",
      'Explain the proposed work before approval',
    ],
  },
  '/aircon-repair-tierboskloof-security-estate-hout-bay': {
    heading: 'Know what the visit has found',
    paragraph: 'Share the fault and any access arrangements when booking at Tierboskloof. After assessing the aircon, we explain what the checks show and discuss the proposed next step. You review the cost before deciding whether to proceed.',
    steps: [
      'Confirm the symptoms and visit details',
      'Assess the unit and explain the findings',
      'Review the next step and quote',
    ],
  },

  // City Bowl / CBD
  '/aircon-repair-bo-kaap': {
    heading: "Find out why the unit won't stay on",
    paragraph: 'Does your aircon stop straight away, or run for a while before switching off? That detail is useful when you book. We assess the fault at your Bo-Kaap property and explain the proposed work before repairs begin.',
    steps: [
      'Establish when the unit stops',
      'Check the fault during assessment',
      'Get approval for the quoted work',
    ],
  },
  '/aircon-repair-devils-peak-estate': {
    heading: 'Longer running times need a closer look',
    paragraph: "If the unit seems to run longer but the room still isn't comfortable, tell us what has changed. We assess your Devil's Peak Estate aircon and explain the findings before recommending what work, if any, should follow.",
    steps: [
      'Discuss the change in performance',
      "Check the unit's operation",
      'Explain any recommended work',
    ],
  },
  '/aircon-repair-gardens': {
    heading: "Work out what the controls aren't telling you",
    paragraph: "If the display responds but the aircon doesn't behave as expected, tell us exactly what you notice. We assess your Gardens unit and explain the findings, so the repair decision isn't based only on what appears on the screen.",
    steps: [
      'Review the controls and symptoms',
      "Check the unit's response",
      'Discuss any recommended repair',
    ],
  },
  '/aircon-repair-higgovale': {
    heading: "Repeated restarting isn't a repair plan",
    paragraph: 'If switching the aircon off and on has become part of using it, describe what happens between restarts. We assess your Higgovale unit and discuss the findings, rather than assuming the temporary improvement explains the fault.',
    steps: [
      'Discuss the restarting pattern',
      "Check the unit's behaviour",
      'Explain the proposed next step',
    ],
  },
  '/aircon-repair-oranjezicht': {
    heading: 'Find out where the problem begins',
    paragraph: 'Water beneath the unit or a change in operation needs checking before a remedy is chosen. We assess your Oranjezicht aircon, explain the findings, and discuss the proposed work rather than assuming the visible symptom tells the whole story.',
    steps: [
      'Examine the reported symptom',
      'Explain what the checks reveal',
      'Agree on any repair before starting',
    ],
  },
  '/aircon-repair-tamboerskloof': {
    heading: 'Describe the change before choosing a fix',
    paragraph: 'Has your aircon become louder, started dripping, or stopped responding? Tell us which symptom you\u2019ve noticed at your Tamboerskloof property. We examine the unit and explain the findings before recommending work or replacement parts.',
    steps: [
      "Identify the change you've noticed",
      'Inspect before recommending parts',
      'Discuss the repair proposal and cost',
    ],
  },
  '/aircon-repair-v-a-waterfront': {
    heading: 'Understand the work before arranging around it',
    paragraph: 'An aircon repair may need planning around your home or working day. We assess the unit at your V&A Waterfront property and explain the proposed work, allowing you to discuss the arrangements before authorising the repair.',
    steps: [
      'Assess the aircon problem',
      'Explain the proposed work',
      'Discuss arrangements and approval',
    ],
  },
  '/aircon-repair-vredehoek': {
    heading: 'Make sense of a problem that comes and goes',
    paragraph: "If the aircon behaves differently from one day to the next, share the pattern you've noticed. We assess your Vredehoek unit and explain what the checks establish, including any uncertainty that remains before a repair is proposed.",
    steps: [
      'Discuss the changing symptoms',
      'Check the reported behaviour',
      'Explain what is confirmed and unresolved',
    ],
  },

  // Southern Suburbs / Constantia Valley
  '/aircon-repair-bergvliet': {
    heading: 'Less adjusting. A better understanding of the fault.',
    paragraph: "If you keep changing the settings without getting comfortable, it's time to understand what's happening. We assess your Bergvliet aircon, explain the issue in plain language, and provide a quote for the proposed repair.",
    steps: [
      'Discuss the settings and symptoms',
      'Check how the aircon responds',
      'Review the quote before repairs start',
    ],
  },
  '/aircon-repair-bishopscourt': {
    heading: 'Give each faulty unit a closer look',
    paragraph: 'If you have more than one aircon, let us know which units are affected and how their symptoms differ. At your Bishopscourt assessment, we check the reported problems and explain what work is proposed for each affected unit.',
    steps: [
      'Identify which units need attention',
      'Assess the faults separately',
      'Set out the proposed repair costs',
    ],
  },
  '/aircon-repair-claremont': {
    heading: 'You describe the problem. We investigate it.',
    paragraph: "You know how your aircon normally behaves, even if you don't know why it has changed. Tell us what you've noticed at your Claremont property. We assess the unit and discuss the findings before suggesting the repair.",
    steps: [
      'Tell us what feels different',
      'Let us assess the unit',
      'Consider the repair quote before proceeding',
    ],
  },
  '/aircon-repair-constantia': {
    heading: 'A repair starts with understanding the problem',
    paragraph: "Water indoors, weak cooling, and a unit that won't start are different complaints. Tell us which applies to your Constantia aircon. We assess the reported fault and explain the proposed work rather than offering a repair without a check.",
    steps: [
      'Establish the main complaint',
      'Examine the affected unit',
      'Explain the repair and quote',
    ],
  },
  '/aircon-repair-dreyersdal-bergvliet-area': {
    heading: 'No technical terms needed',
    paragraph: '\u201cIt starts, then stops\u201d is a useful place to begin. Describe the problem as you experience it at your Dreyersdal property. We assess the aircon and explain what we find, including the work and cost proposed.',
    steps: [
      'Describe what happens when it runs',
      'Get the findings explained clearly',
      'Approve the repair before it begins',
    ],
  },
  '/aircon-repair-high-constantia-security-estate': {
    heading: 'Start with what happens when it turns on',
    paragraph: 'Does the unit respond, make a sound, or stop almost immediately? Walk us through what you notice with your High Constantia aircon. We assess the problem and explain the proposed repair before you make a decision.',
    steps: [
      'Review the startup symptoms',
      'Examine the reported fault',
      'Agree on the repair and cost',
    ],
  },
  '/aircon-repair-kenilworth': {
    heading: "When the setting and the room don't agree",
    paragraph: "You've chosen a temperature, but the room never seems comfortable. Tell us what happens during a typical run. We assess your Kenilworth aircon and explain the findings before discussing which repair is proposed and why.",
    steps: [
      "Review the performance you're getting",
      'Check the reported cooling problem',
      'Discuss the repair and its price',
    ],
  },
  '/aircon-repair-kirstenhof': {
    heading: 'Check the reason for unexpected stops',
    paragraph: 'Does your aircon struggle to start, or switch off after running? Describe which happens at your Kirstenhof property. We assess the unit and explain what the checks show before recommending a repair or further investigation.',
    steps: [
      'Establish when the unit fails',
      'Assess the reported problem',
      'Explain what should happen next',
    ],
  },
  '/aircon-repair-marina-da-gama-muizenberg': {
    heading: 'Different complaints need a proper check',
    paragraph: "Dripping water, poor cooling, and unexpected stops shouldn't all receive the same assumed answer. We assess the issue with your Marina da Gama aircon, explain the findings, and discuss the repair that is actually being proposed.",
    steps: [
      'Identify the main complaint',
      'Check before recommending a remedy',
      'Quote for the proposed work',
    ],
  },
  '/aircon-repair-newlands': {
    heading: 'Look beyond whether the unit is running',
    paragraph: "Lights and airflow don't tell the whole story when the room stays uncomfortable. Describe how your Newlands aircon is performing. We assess the reported problem and explain what work is proposed before repairs are authorised.",
    steps: [
      "Discuss the room's cooling problem",
      "Examine the aircon's operation",
      'Explain the proposed repair clearly',
    ],
  },
  '/aircon-repair-rondebosch': {
    heading: 'Sudden fault or gradual change? Tell us.',
    paragraph: 'Some aircon problems appear overnight; others become noticeable over weeks. That history is useful when arranging your Rondebosch assessment. We inspect the unit, explain what the findings show, and discuss the repair before work begins.',
    steps: [
      'Establish when the trouble started',
      'Check the reported symptoms',
      'Agree on the proposed repair',
    ],
  },
  '/aircon-repair-rondebosch-oval-estate': {
    heading: 'A clear explanation before the repair',
    paragraph: "You shouldn't have to approve work based on a list of unfamiliar parts. We assess your aircon at Rondebosch Oval and explain the proposal in everyday language, including the quoted cost and what the work involves.",
    steps: [
      'Assess the problem with the unit',
      'Explain the proposed work plainly',
      'Get your approval before proceeding',
    ],
  },
  '/aircon-repair-silverhurst-security-estate-constantia': {
    heading: 'Check the condition behind the complaint',
    paragraph: 'Tell us how your aircon normally runs and what feels different now. We assess the unit at your Silverhurst property and explain the findings, giving you a clearer basis for deciding whether to approve the proposed repair.',
    steps: [
      'Discuss normal and current operation',
      'Assess the reported change',
      'Review the findings and repair proposal',
    ],
  },
  '/aircon-repair-silvertree-estate-tokai': {
    heading: 'A repair plan you can understand',
    paragraph: "Working around an aircon fault is inconvenient; an unclear repair proposal doesn't help. We assess your Silvertree Estate unit and explain the recommended work, so you know what is being proposed before agreeing to the cost.",
    steps: [
      'Assess the problem you report',
      'Explain the scope of the repair',
      'Confirm the quote before proceeding',
    ],
  },
  '/aircon-repair-steenberg': {
    heading: "You don't need to name the faulty part",
    paragraph: "There's no need to arrive with a diagnosis. Describe the problem with your Steenberg aircon in your own words. We assess the unit, explain the findings, and set out the proposed repair so you can make an informed decision.",
    steps: [
      'Explain what the aircon is doing',
      'Get the assessment findings explained',
      'Review the repair quote',
    ],
  },
  '/aircon-repair-stonehurst-security-estate-tokai': {
    heading: 'Clear findings. An agreed next step.',
    paragraph: 'An assessment should leave you understanding more about the problem, not less. We check your Stonehurst aircon and explain what needs attention, including any proposed repair and its cost, before you decide what work to approve.',
    steps: [
      'Assess the affected aircon',
      'Explain what needs attention',
      'Confirm the next step with you',
    ],
  },
  '/aircon-repair-tokai': {
    heading: 'Check the problem before buying the solution',
    paragraph: 'Less cooling, extra noise, or unexpected stops can leave you unsure what the aircon needs. We assess your Tokai unit and explain any recommended work, so you can consider the repair proposal before spending on it.',
    steps: [
      'Assess the symptoms you report',
      'Explain the recommended remedy',
      'Get agreement on the quoted work',
    ],
  },
  '/aircon-repair-zwaanswyk': {
    heading: 'Start with what changed and when',
    paragraph: 'Your account of the problem helps explain why you booked the visit. Tell us what has changed with your Zwaanswyk aircon. We assess the unit and explain the findings before discussing any proposed repair or additional checks.',
    steps: [
      'Establish when the change began',
      "Assess the aircon's condition and operation",
      'Explain the proposed next step',
    ],
  },

  // Peninsula / False Bay
  '/aircon-repair-capri-village-fish-hoek': {
    heading: 'An occasional fault still deserves attention',
    paragraph: "Some problems happen every time; others seem to disappear before anyone can see them. Tell us the pattern you've noticed with your Capri Village aircon. We consider that history during the assessment and explain the next steps.",
    steps: [
      'Discuss when the fault appears',
      'Assess the unit and reported symptoms',
      'Explain any findings or testing limits',
    ],
  },
  '/aircon-repair-clovelly': {
    heading: 'Tell us what happens before it stops',
    paragraph: 'If your aircon runs for a while and then cuts out, describe the sequence you notice. That gives us a starting point for your Clovelly assessment. We check the unit and discuss what the findings suggest should happen next.',
    steps: [
      'Note how long the unit runs',
      'Assess the shutdown problem',
      'Discuss the proposed repair or further checks',
    ],
  },
  '/aircon-repair-de-goede-hoop-security-estate-noordhoek': {
    heading: 'Make the assessment easier to arrange',
    paragraph: 'When booking at De Goede Hoop, share the unit details, symptoms, and any access arrangements. During the visit, we assess the problem and explain the findings. You receive a repair proposal before deciding whether to go ahead.',
    steps: [
      'Share the fault and access details',
      'Have the unit assessed',
      'Review the proposed work and cost',
    ],
  },
  '/aircon-repair-glencairn': {
    heading: 'Look at the pattern, not just the moment',
    paragraph: 'Does the problem happen at startup, after a long run, or only occasionally? Share that pattern when booking your Glencairn assessment. We examine the unit and explain what the checks establish, including anything that remains uncertain.',
    steps: [
      'Record when the fault happens',
      'Assess the reported behaviour',
      'Explain confirmed findings and uncertainties',
    ],
  },
  '/aircon-repair-kalk-bay': {
    heading: 'Take the change in airflow seriously',
    paragraph: 'If the airflow feels weaker or different, explain when you first noticed it. We assess your Kalk Bay aircon alongside the symptoms you report, then discuss the findings and cost of any recommended repair.',
    steps: [
      'Discuss the airflow complaint',
      'Inspect how the unit operates',
      'Explain any work before quoting',
    ],
  },
  '/aircon-repair-lake-michelle-security-lifestyle-estate-noordhoek': {
    heading: 'Find out why reliability has changed',
    paragraph: 'An aircon that works one day and struggles the next can be frustrating. Tell us when the trouble began at your Lake Michelle property. We assess its behaviour and explain what we can establish during the visit.',
    steps: [
      'Discuss the history of the problem',
      "Check the unit's operation",
      'Set out the findings and next steps',
    ],
  },
  '/aircon-repair-muizenberg': {
    heading: 'Get the information you need to decide',
    paragraph: 'Before deciding what to spend on your aircon, understand what the assessment shows. We check your Muizenberg unit and discuss the findings, proposed work, and quoted cost. You can ask questions before agreeing to the repair.',
    steps: [
      'Have the fault assessed',
      'Review the work and cost',
      'Decide whether to proceed',
    ],
  },
  '/aircon-repair-noordhoek': {
    heading: 'Turn the symptoms into a clear next step',
    paragraph: "If your aircon won't respond or isn't cooling, start by telling us what happens when you use it. We assess the unit at your Noordhoek property and discuss what the findings mean for the next step.",
    steps: [
      "Share the symptoms you've noticed",
      'Get the unit assessed',
      'Review the recommendation and quote',
    ],
  },
  '/aircon-repair-plumstead': {
    heading: "When changing settings hasn't helped",
    paragraph: "If adjusting the temperature and mode hasn't solved the complaint, explain what you've tried. We assess your Plumstead aircon and discuss the findings, so the next decision is based on a check rather than another guess.",
    steps: [
      'Review the problem and previous adjustments',
      'Assess the affected unit',
      'Explain any recommended work and cost',
    ],
  },
  '/aircon-repair-scarborough': {
    heading: 'Find out what made the unit unreliable',
    paragraph: 'If an aircon that used to work well has become unpredictable, tell us what has changed. We assess your Scarborough unit and discuss the findings, including whether a repair or additional investigation is the proposed next step.',
    steps: [
      'Review the change in behaviour',
      "Assess the unit's operation",
      'Explain the recommended next step',
    ],
  },
  '/aircon-repair-st-james': {
    heading: "Look into the change you've noticed",
    paragraph: 'A different sound or less comfortable room can be your first sign that something has changed. We assess your St James aircon, explain what the checks show, and discuss any recommended work before repairs begin.',
    steps: [
      'Talk through the change',
      "Check the unit's operation",
      'Explain the proposed work for approval',
    ],
  },

  // Century City
  '/aircon-repair-century-city': {
    heading: 'Understand the repair before making plans',
    paragraph: 'An aircon problem can interrupt the use of a room at home or work. During your Century City assessment, we explain what needs attention and discuss the proposed repair, so you can make arrangements with a clearer understanding of the work.',
    steps: [
      'Explain the problem and its impact',
      'Review the assessment findings',
      'Discuss the repair arrangements and cost',
    ],
  },
  '/aircon-repair-island-club-century-city': {
    heading: 'Understand the fault and the arrangements',
    paragraph: "When arranging an assessment at Island Club, tell us about the aircon problem and building access. We examine the unit, discuss the findings, and explain the proposed repair so you know what you're being asked to approve.",
    steps: [
      'Confirm the fault and access details',
      'Assess the affected aircon',
      'Review the repair proposal together',
    ],
  },
  '/aircon-repair-knightsbridge-century-city': {
    heading: 'Clear findings before repair approval',
    paragraph: 'Share the symptoms and any access requirements when booking at Knightsbridge. During the assessment, we examine the aircon and explain what needs attention. The proposed work and cost are discussed before you decide whether to authorise the repair.',
    steps: [
      'Confirm the booking details',
      'Explain the assessment findings',
      'Obtain approval for the quoted repair',
    ],
  },

  // Northern Suburbs
  '/aircon-repair-big-bay': {
    heading: 'Start with a check, not a guess',
    paragraph: 'An aircon that blows air without cooling needs an assessment, not an assumed solution. Tell us what your Big Bay unit is doing. We check its operation and explain the next steps before you decide whether to proceed.',
    steps: [
      'Confirm what the unit is doing',
      'Assess the reported cooling fault',
      'Explain the repair options and cost',
    ],
  },
  '/aircon-repair-bloubergstrand': {
    heading: 'Small changes are worth explaining',
    paragraph: "Weaker airflow, a different sound, or longer cooling times can be hard to put into words. Describe the change as you've experienced it. We assess your Bloubergstrand aircon and explain what the findings mean for the repair.",
    steps: [
      'Note what has changed',
      "Check the unit's performance",
      'Discuss the findings before quoting',
    ],
  },
  '/aircon-repair-burgundy-estate': {
    heading: 'Get the problem explained in plain language',
    paragraph: "You don't need a technical explanation ready when you call. Tell us what your Burgundy Estate aircon is doing and how it affects the room. We examine the unit and explain the repair proposal without unnecessary jargon.",
    steps: [
      'Describe the problem in your own words',
      'Get a clear explanation of the findings',
      'Review the cost before agreeing',
    ],
  },
  '/aircon-repair-clara-anna-fontein-durbanville': {
    heading: 'The right starting point is an assessment',
    paragraph: "A unit that won't respond needs a closer look before a repair can be recommended. Share what happens when you use your Clara Anna Fontein aircon. We examine the problem and explain what we can establish during the visit.",
    steps: [
      'Check the reported lack of response',
      'Explain what the assessment shows',
      'Quote for any proposed repair',
    ],
  },
  '/aircon-repair-edgemead': {
    heading: 'Repair decisions need more than a hunch',
    paragraph: 'Before agreeing to new parts, find out what the assessment shows. We inspect your Edgemead aircon, explain the reported fault, and discuss the proposed remedy. Ask questions about the quote before deciding whether to proceed.',
    steps: [
      'Assess before recommending parts',
      'Explain the reason for the repair',
      'Confirm the quoted work with you',
    ],
  },
  '/aircon-repair-graanendal-lifestyle-estate-durbanville': {
    heading: 'A change in performance needs an explanation',
    paragraph: "Perhaps the difference is subtle: a little more noise or less cooling than before. Tell us what you've noticed with your Graanendal aircon. We assess the unit and explain whether any work is recommended.",
    steps: [
      "Describe the change you've noticed",
      'Have the aircon assessed',
      'Review any proposed work and cost',
    ],
  },
  '/aircon-repair-loevenstein': {
    heading: "Check what's behind the weaker cooling",
    paragraph: 'Less airflow and less cooling can feel similar from across the room. Tell us what you notice at the unit and in the space. We assess your Loevenstein aircon and explain the work being recommended.',
    steps: [
      'Review the symptoms with you',
      "Assess the aircon's performance",
      'Explain the repair before proceeding',
    ],
  },
  '/aircon-repair-parklands': {
    heading: 'Repeated stops deserve an explanation',
    paragraph: 'When your aircon keeps stopping, tell us how long it runs and what happens before it shuts down. We use that description during your Parklands assessment, then explain what we find and what work is proposed.',
    steps: [
      'Discuss the stopping pattern',
      'Assess how the unit operates',
      'Review the proposed repair before approval',
    ],
  },
  '/aircon-repair-sonstraal-durbanville': {
    heading: 'Find out why cooling takes longer',
    paragraph: 'If your room takes longer to cool than it used to, describe the difference when booking. We assess your Sonstraal aircon and explain the findings before recommending any work or asking you to approve a repair quote.',
    steps: [
      'Review the change in cooling time',
      "Check the aircon's performance",
      'Discuss any proposed repair',
    ],
  },
  '/aircon-repair-sonstraal-heights-durbanville': {
    heading: 'Tell us what it no longer does',
    paragraph: 'Sometimes the easiest way to explain a fault is to describe what has stopped happening. Tell us about your Sonstraal Heights aircon. We assess the unit and talk you through the findings before proposing the next step.',
    steps: [
      'Describe the missing or changed function',
      'Have the unit assessed',
      'Review the next step and its cost',
    ],
  },
  '/aircon-repair-sunningdale': {
    heading: 'When the room stays warm, check the unit',
    paragraph: "You've switched the aircon on, but you're still waiting to feel comfortable. Tell us how it runs at your Sunningdale property. We assess the cooling complaint and explain the proposed repair before any agreed work begins.",
    steps: [
      'Review the cooling complaint',
      "Examine the unit's operation",
      'Quote for the proposed repair',
    ],
  },
  '/aircon-repair-welgemoed': {
    heading: 'Check why comfort has become harder to reach',
    paragraph: 'Taking longer to cool or stopping too soon can make an aircon frustrating to use. We assess your Welgemoed unit, discuss what we find, and explain the proposed repair before asking you to agree to the cost.',
    steps: [
      'Review the cooling and stopping pattern',
      'Assess how the unit operates',
      'Discuss the proposed repair quote',
    ],
  },

  // Helderberg
  '/aircon-repair-de-zalze-golf-estate-somerset-west-stellenbosch-border': {
    heading: 'Know your options before deciding',
    paragraph: 'When your aircon stops working properly, you need enough information to make a decision. We assess the unit at your De Zalze property, explain the findings, and discuss the proposed repair without asking you to approve unexplained work.',
    steps: [
      "Check the aircon's condition and operation",
      'Discuss the assessment findings',
      'Decide after reviewing the repair proposal',
    ],
  },
  '/aircon-repair-erinvale-golf-estate-somerset-west': {
    heading: 'Get a clear picture of the work',
    paragraph: 'Whether your aircon is leaking, making noise, or cooling poorly, the next step is to establish what needs attention. We assess the unit at your Erinvale property and explain the proposed repair before you authorise it.',
    steps: [
      'Check the symptoms you report',
      'Describe the work being recommended',
      'Agree on the cost before starting',
    ],
  },
  '/aircon-repair-gordons-bay': {
    heading: 'Find out why cooling has fallen short',
    paragraph: "When the aircon is running but the room stays warm, you need more than another change of settings. We assess your Gordon's Bay unit, explain the findings, and discuss the repair proposal before work starts.",
    steps: [
      "Establish what cooling you're getting",
      'Check the unit before proposing work',
      'Quote and obtain your approval',
    ],
  },
  '/aircon-repair-somerset-west': {
    heading: 'Check the fault before choosing the remedy',
    paragraph: "A unit that won't start and one that cools poorly need their own assessment. Explain the issue at your Somerset West property. We inspect the aircon and discuss the proposed work rather than assuming every complaint has the same answer.",
    steps: [
      'Establish the symptoms',
      'Assess the affected unit',
      'Explain the recommendation and cost',
    ],
  },

  // Cape Winelands
  '/aircon-repair-franschhoek': {
    heading: 'Check why the room stays uncomfortable',
    paragraph: "Setting a lower temperature hasn't helped, and the room still feels wrong. Tell us how your Franschhoek aircon is performing. We examine the unit and explain what we find before discussing a repair and its cost.",
    steps: [
      'Review the cooling complaint',
      "Assess the aircon's performance",
      'Present the proposed repair for approval',
    ],
  },
  '/aircon-repair-paarl': {
    heading: 'Use the display as a starting point',
    paragraph: 'If your aircon shows a message or flashing light, share it when you book. We assess the unit at your Paarl property and explain the findings. Any proposed repair is discussed before you approve the work.',
    steps: [
      'Record any displayed message',
      'Check the unit and reported fault',
      'Explain the repair and quoted cost',
    ],
  },
  '/aircon-repair-stellenbosch': {
    heading: "Check why the settings aren't helping",
    paragraph: "If changing modes or temperatures makes little difference, tell us what you've tried. We assess your Stellenbosch aircon and explain what the findings suggest, including the proposed work and cost before you authorise the repair.",
    steps: [
      'Discuss the settings and symptoms',
      "Assess the unit's response",
      'Agree on the work before starting',
    ],
  },
  '/aircon-repair-val-de-vie-estate-paarl': {
    heading: 'An inspection before a repair recommendation',
    paragraph: 'Tell us what your aircon is doing and when the problem began. At your Val de Vie assessment, we inspect the unit and explain the findings, then discuss the proposed repair and cost before you decide to proceed.',
    steps: [
      "Review the unit's recent behaviour",
      'Assess the reported fault',
      'Explain the repair for your approval',
    ],
  },
};

for (const [route, diagnosis] of Object.entries(LOCATION_DIAGNOSIS)) {
  if (LOCATION_PAGES[route]) LOCATION_PAGES[route].diagnosis = diagnosis;
}

// Shared accordion entries for the Problems section (Layout494) on every
// aircon repair page — symptom descriptions that help visitors explain the
// problem rather than diagnose a failed component.
const SHARED_AIRCON_PROBLEMS = [
  {
    heading: 'Not cooling properly',
    description: "The unit switches on, but the room stays warm or takes much longer to cool. Tell us whether the air feels cool at the outlet and whether the problem started suddenly or developed over time.",
  },
  {
    heading: 'Leaking water indoors',
    description: "You've noticed dripping from the indoor unit, water on the wall, or a wet patch below it. Describe where the water appears and whether it happens while the aircon runs or after it stops.",
  },
  {
    heading: 'Making an unfamiliar noise',
    description: "The aircon sounds different from usual — a rattle, buzz, click, or another noise you can't quite describe. Let us know where the sound seems to come from and when you hear it.",
  },
  {
    heading: "Won't switch on",
    description: "The unit doesn't respond, the display stays blank, or it shows a light or message without starting. Tell us what happens when you try to turn it on and share any message shown.",
  },
  {
    heading: 'Keeps starting and stopping',
    description: "The aircon starts, stops, and starts again without keeping the room comfortable. Explain roughly how long it runs each time and whether you've noticed any lights, messages, or other changes.",
  },
];

const SHARED_REFRIGERATION_PROBLEMS = [
  {
    heading: 'Not keeping cold',
    description: "The equipment is running, but the inside feels warmer than expected or the displayed temperature is different from usual. Tell us what type of unit you have and when you noticed the change.",
  },
  {
    heading: 'Water around the unit',
    description: "You've noticed water inside, underneath, or around the equipment. Describe where it collects and whether it appears continuously or only at certain times.",
  },
  {
    heading: 'Making an unfamiliar noise',
    description: 'The unit has developed a rattle, buzz, click, or another sound that is different from normal. Explain where the noise seems to come from and whether it happens all the time.',
  },
  {
    heading: "Won't switch on",
    description: 'The equipment appears unresponsive, the display stays blank, or it shows a message without operating as expected. Share what happens when you try to use it, including any displayed message.',
  },
  {
    heading: 'Temperature keeps changing',
    description: 'The unit seems cold at one point and warmer later, or its displayed temperature keeps changing. Tell us what you have observed and roughly when those changes happen.',
  },
];

// Per-page Problems section content (Layout494): an H2 and intro paragraph.
// Aircon pages share SHARED_AIRCON_PROBLEMS for the accordion entries;
// /refrigeration-repairs uses its own label and item set.
export const LOCATION_PROBLEMS = {
  // Existing Search Console URLs
  '/aircons-installer-kuils-river': {
    heading: "Won't start, won't cool, or won't stay on?",
    intro: "Choose the description that fits your aircon, then explain what happens during use. For your Kuils River enquiry, include any lights, messages, water, or unusual sounds you've noticed.",
  },
  '/aircons-installation-melkbosstrand': {
    heading: 'Is your existing aircon giving trouble?',
    intro: 'If a unit you already use has stopped working properly, describe what has changed. Choose the closest symptom below when enquiring about your existing aircon in Melkbosstrand.',
  },
  '/aircons-installer-fish-hoek': {
    heading: 'Not working the way it used to?',
    intro: 'Compare a normal run with what happens now. Tell us where your Fish Hoek aircon falls short, whether that means warmer air, a new noise, leaking, or trouble staying on.',
  },
  '/aircons-installer-durbanville': {
    heading: 'Which part of using it has changed?',
    intro: 'Is it difficult to start, less effective at cooling, or prone to stopping? Tell us what has changed with your Durbanville aircon rather than trying to identify the cause yourself.',
  },
  '/aircons-installation-milnerton': {
    heading: 'You can hear it running—but is it cooling?',
    intro: "Tell us whether the unit is moving air without making the room comfortable. If your Milnerton aircon has another issue, use the descriptions below to explain what you're noticing.",
  },
  '/aircons-installations-pinelands': {
    heading: "Something seems wrong, but you're not sure what?",
    intro: "You don't need a precise explanation before getting in touch. Describe the sound, water, lack of cooling, or other symptom you've noticed with your Pinelands aircon.",
  },
  '/aircons-installer-grassy-park': {
    heading: 'Start with a simple description',
    intro: '\u201cIt turns on, then stops\u201d gives us something to discuss. Tell us what your Grassy Park aircon does, using the examples below only if they help you explain it.',
  },
  '/aircons-installer-lansdowne': {
    heading: 'Constantly changing settings to stay comfortable?',
    intro: 'If you keep adjusting the aircon without getting the result you want, tell us what happens. Describe the issue at your Lansdowne property, including any symptoms beyond poor cooling.',
  },
  '/aircons-installations-strandfontein': {
    heading: 'Aircon running, room still warm?',
    intro: 'Explain whether the air feels cool at the unit and whether the room changes temperature at all. Other problems with your Strandfontein aircon can be described using the examples below.',
  },
  '/aircons-installer-retreat': {
    heading: 'What response do you get from the unit?',
    intro: 'Does it stay silent, show a light, or start only briefly? Tell us what happens when you try to use your Retreat aircon, or describe another symptom from the list.',
  },
  '/aircons-installer-table-view': {
    heading: 'Is the room staying warmer than you expect?',
    intro: 'If the aircon runs without reaching a comfortable result, describe its behaviour and how long the problem has been present. Other symptoms with your Table View unit can be explained below.',
  },
  '/aircons-installer-melkbosstrand': {
    heading: 'Does the trouble follow a pattern?',
    intro: 'Perhaps the aircon starts well and then stops, or cools differently from one use to the next. Explain what you notice with your Melkbosstrand unit and how often it happens.',
  },
  '/aircons-installer-simon-s-town': {
    heading: 'What is different from the last normal run?',
    intro: "Tell us whether the change involves sound, cooling, water, or the unit's response. These descriptions can help you explain what is happening with your Simon's Town aircon.",
  },
  '/aircons-installation-wynberg': {
    heading: 'What keeps going wrong?',
    intro: 'Whether the problem is new or something that keeps returning, describe how it affects your use of the aircon. Choose the closest example for your Wynberg unit and add any relevant details.',
  },
  '/aircons-installations-kommetjie': {
    heading: 'Has it stopped—or become unreliable?',
    intro: 'Let us know whether the aircon no longer works at all or only gives trouble sometimes. Describe what you notice at your Kommetjie property using the examples below.',
  },
  '/aircons-installer-kensington': {
    heading: 'A new sound, a drip, or less cooling?',
    intro: 'Tell us what first made you think the aircon needed attention. Include when it happens and whether anything else has changed with the unit at your Kensington property.',
  },
  '/refrigeration-repairs': {
    label: 'Refrigeration problems',
    heading: 'What has changed with your refrigeration unit?',
    intro: 'Is the equipment struggling to keep cold, showing water, or behaving differently from usual? Tell us what type of unit you have and choose the closest description below.',
    items: SHARED_REFRIGERATION_PROBLEMS,
  },
  '/aircons-installations-camps-bay': {
    heading: 'It switches on. Does it still do the job?',
    intro: "Your aircon may start normally without cooling the way it used to. Tell us what happens during use at your Camps Bay property, including any other changes you've noticed.",
  },
  '/aircons-installations-meadowridge': {
    heading: "Why doesn't the room feel right?",
    intro: "If the aircon no longer keeps the space comfortable, explain what you're experiencing. Tell us about the airflow, cooling, or any other change at your Meadowridge property.",
  },
  '/aircons-installer-ridgewood': {
    heading: 'Has cooling the room become a struggle?',
    intro: 'Explain whether the aircon runs longer, feels less effective, or stops before the room is comfortable. You can also report noise, leaks, or startup problems with your Ridgewood unit.',
  },
  '/aircons-installations-platterkloof': {
    heading: 'Does the same problem keep returning?',
    intro: 'Tell us how the aircon behaves between troublesome periods and when the symptom comes back. You can use these descriptions to explain a recurring issue at your Plattekloof property.',
  },
  '/aircons-installation-monte-vista': {
    heading: 'The controls respond. Does the unit?',
    intro: "Explain what happens after you select a mode or temperature. For your Monte Vista enquiry, include anything unusual about the aircon's startup, cooling, sound, or stopping pattern.",
  },

  // Atlantic Seaboard
  '/aircon-repair-alphen-estate-constantia': {
    heading: 'What has changed with your aircon?',
    intro: 'Is the room warmer than usual, or has the unit started doing something unexpected? Choose the closest description below when enquiring about your aircon in Alphen Estate.',
  },
  '/aircon-repair-avignon-security-estate-hout-bay': {
    heading: 'Tell us what happens when it runs',
    intro: "A change in sound, cooling, or water around the unit can be difficult to explain. Use these descriptions to tell us what you've noticed at your Avignon Estate property.",
  },
  '/aircon-repair-bakoven': {
    heading: "Aircon on, but something isn't right?",
    intro: 'Perhaps it still runs but no longer cools the room, or it has developed a new noise. Tell us which description fits your Bakoven aircon — or explain the problem in your own words.',
  },
  '/aircon-repair-bantry-bay': {
    heading: 'Which problem are you noticing?',
    intro: "You don't need to identify the faulty part before getting in touch. Start with what you can hear, see, or feel when using your aircon in Bantry Bay.",
  },
  '/aircon-repair-bergendal-security-estate-hout-bay': {
    heading: 'Is your aircon behaving differently?',
    intro: 'If the unit has become noisier, less effective, or harder to keep running, describe the change. The examples below can help you explain the issue at your Bergendal Estate property.',
  },
  '/aircon-repair-clifton': {
    heading: 'Running, leaking, rattling — or not responding?',
    intro: 'Start with the symptom rather than trying to name a component. Tell us which of these descriptions fits your Clifton aircon and whether the problem is constant or occasional.',
  },
  '/aircon-repair-fresnaye': {
    heading: 'It starts — but what happens next?',
    intro: "Does it keep running, stop unexpectedly, or blow air that doesn't feel cool? Tell us what happens after your Fresnaye aircon switches on, including anything unusual you've noticed.",
  },
  '/aircon-repair-green-point': {
    heading: "Tell us what isn't right",
    intro: 'Whether the aircon has stopped working or is simply no longer comfortable to use, explain the complaint. Start with one of these descriptions for your Green Point enquiry, then add your own details.',
  },
  '/aircon-repair-hanging-meadows-security-estate-hout-bay': {
    heading: 'What do you notice when you use it?',
    intro: 'Share what the aircon does at your Hanging Meadows property, including any lights or messages. If the issue involves sound, water, or cooling instead, use the closest description below.',
  },
  '/aircon-repair-hout-bay': {
    heading: 'Aircon trouble? Start with the symptoms.',
    intro: 'A warm room, indoor drip, or unexpected stop is easier to explain than an unfamiliar technical term. Tell us what your Hout Bay aircon is doing and when the problem began.',
  },
  '/aircon-repair-kenrock-security-estate-hout-bay': {
    heading: 'What has stopped working normally?',
    intro: "Think about how the aircon usually behaves and what is different now. Tell us about the change at your KenRock Estate property, even if it doesn't fit neatly into one description.",
  },
  '/aircon-repair-llandudno': {
    heading: 'What makes the aircon difficult to use?',
    intro: "Perhaps you can't rely on it to start, stay on, or cool the room. Explain what is getting in the way at your Llandudno property and when you notice the problem.",
  },
  '/aircon-repair-mouille-point': {
    heading: "Hearing something you haven't heard before?",
    intro: 'Tell us what the sound is like and whether it happens at startup or while the unit runs. You can also describe cooling, water, or other problems with your Mouille Point aircon.',
  },
  '/aircon-repair-ruyteplaats-security-estate-hout-bay': {
    heading: 'Explain the symptom, not the cause',
    intro: 'Tell us what you notice when using your aircon at Ruyteplaats. Whether it involves cooling, water, noise, or switching on, the descriptions below can help you put the problem into words.',
  },
  '/aircon-repair-sea-point': {
    heading: 'What is getting in the way of comfort?',
    intro: 'The room might stay warm, the unit might be noisy, or it may not start at all. Choose the closest description for your Sea Point aircon and add what makes the problem noticeable.',
  },
  '/aircon-repair-stoneybrook-security-estate-hout-bay': {
    heading: 'Does the problem come and go?',
    intro: 'Tell us when your aircon behaves normally and when it gives trouble. The pattern may be easier to describe than the cause when enquiring about your Stoneybrook unit.',
  },
  '/aircon-repair-three-anchor-bay': {
    heading: 'Does its performance match what you selected?',
    intro: "If your chosen temperature or mode doesn't give the result you expect, explain the difference. Include any other symptoms you've noticed with your Three Anchor Bay aircon.",
  },
  '/aircon-repair-tierboskloof-security-estate-hout-bay': {
    heading: 'Tell us what happens during use',
    intro: 'Describe how the unit starts, how it runs, and where the problem appears. These examples can help with your Tierboskloof enquiry, even if your aircon has more than one symptom.',
  },

  // City Bowl / CBD
  '/aircon-repair-bo-kaap': {
    heading: 'What happens when you switch it on?',
    intro: 'Does the unit stay silent, start briefly, or run without cooling? Walk us through what your Bo-Kaap aircon does, starting from the moment you try to use it.',
  },
  '/aircon-repair-devils-peak-estate': {
    heading: 'Is it running longer without much result?',
    intro: 'If your aircon seems to work harder without making the room comfortable, tell us what has changed. You can also describe noise, water, or startup problems at your Devil\u2019s Peak Estate property.',
  },
  '/aircon-repair-gardens': {
    heading: 'Does the unit respond as expected?',
    intro: "The display may light up while the aircon does something different from what you've selected. Describe the response at your Gardens property, or choose another symptom from the list below.",
  },
  '/aircon-repair-higgovale': {
    heading: 'Are you restarting it to keep it going?',
    intro: 'If turning the unit off and on has become part of using it, explain what happens between restarts. You can also tell us about other changes with your Higgovale aircon.',
  },
  '/aircon-repair-oranjezicht': {
    heading: 'Noticed water, noise, or weaker cooling?',
    intro: "Explain what first caught your attention and whether it has happened again. Your Oranjezicht aircon problem doesn't need a technical label — just a clear account of what you've seen or heard.",
  },
  '/aircon-repair-tamboerskloof': {
    heading: 'What first caught your attention?',
    intro: "Perhaps it was a drip, a louder sound, or a room that wouldn't cool. Tell us what you noticed first and how your Tamboerskloof aircon has behaved since then.",
  },
  '/aircon-repair-v-a-waterfront': {
    heading: 'What is interrupting normal use?',
    intro: 'Explain what happens when you try to use the aircon at your V&A Waterfront property. Choose the closest description below and mention whether the problem is continuous or occasional.',
  },
  '/aircon-repair-vredehoek': {
    heading: 'Does it behave differently from day to day?',
    intro: "A problem that isn't always present can be awkward to explain. Tell us what changes between uses of your Vredehoek aircon and whether the symptoms follow a pattern.",
  },

  // Southern Suburbs / Constantia Valley
  '/aircon-repair-bergvliet': {
    heading: 'Still adjusting it without getting comfortable?',
    intro: 'When the usual settings no longer give you the result you expect, tell us what happens instead. Here are five ways to describe an aircon problem at your Bergvliet property.',
  },
  '/aircon-repair-bishopscourt': {
    heading: 'Which unit needs attention — and why?',
    intro: 'If you have several aircons, let us know whether one or more are affected. Describe the symptoms for each unit when contacting us about your Bishopscourt property.',
  },
  '/aircon-repair-claremont': {
    heading: 'You know what feels different',
    intro: "You may not know why the aircon has changed, but you know how it normally behaves. Tell us what you've noticed at your Claremont property, using these descriptions as a starting point.",
  },
  '/aircon-repair-constantia': {
    heading: 'What is your aircon doing differently?',
    intro: "Water where it shouldn't be, weaker cooling, or an unresponsive unit are all worth describing clearly. Tell us what is happening with your Constantia aircon rather than guessing the cause.",
  },
  '/aircon-repair-dreyersdal-bergvliet-area': {
    heading: 'No technical description needed',
    intro: 'A straightforward account of what happens is enough to begin. Choose the closest example below or explain the issue with your Dreyersdal aircon in the words you would normally use.',
  },
  '/aircon-repair-high-constantia-security-estate': {
    heading: 'What happens at startup?',
    intro: 'Does your aircon respond immediately, take several attempts, or do nothing at all? Tell us what you notice at your High Constantia property, including any problem that appears after it starts.',
  },
  '/aircon-repair-kenilworth': {
    heading: 'Does the room match the setting?',
    intro: "You've selected a temperature, but the room never seems to reach a comfortable point. Describe how your Kenilworth aircon runs and whether there are any other symptoms alongside the cooling problem.",
  },
  '/aircon-repair-kirstenhof': {
    heading: 'Trouble starting — or staying on?',
    intro: 'Let us know whether your aircon fails to start or stops after it has been running. For other problems at your Kirstenhof property, choose the closest symptom and explain what happens.',
  },
  '/aircon-repair-marina-da-gama-muizenberg': {
    heading: 'Which description sounds familiar?',
    intro: 'A drip, an unexpected shutdown, or air that no longer feels cool can each make the unit difficult to use. Tell us which symptoms affect your Marina da Gama aircon.',
  },
  '/aircon-repair-newlands': {
    heading: 'Running, but not keeping you comfortable?',
    intro: "Lights and airflow may be present even though the room doesn't feel right. Describe the result you're getting from your Newlands aircon, along with any other changes you've noticed.",
  },
  '/aircon-repair-rondebosch': {
    heading: 'Did it stop suddenly or change over time?',
    intro: 'Explain whether the problem appeared all at once or became noticeable gradually. Then choose the symptom that best fits what your Rondebosch aircon is doing now.',
  },
  '/aircon-repair-rondebosch-oval-estate': {
    heading: "What isn't your aircon doing?",
    intro: 'Perhaps it no longer cools the room, responds to the controls, or stays on. Describe the missing or changed function when enquiring about your aircon at Rondebosch Oval.',
  },
  '/aircon-repair-silverhurst-security-estate-constantia': {
    heading: 'How does it behave compared with before?',
    intro: 'Think about its usual sound, cooling, and response to the controls. Tell us what has changed with your Silverhurst aircon, even if the difference is difficult to describe precisely.',
  },
  '/aircon-repair-silvertree-estate-tokai': {
    heading: 'Are you working around an aircon problem?',
    intro: 'Perhaps you avoid one setting, restart the unit, or leave it off because of the noise. Tell us what makes your Silvertree Estate aircon inconvenient to use.',
  },
  '/aircon-repair-steenberg': {
    heading: "You don't need the technical name",
    intro: 'Tell us about the problem as you experience it. These descriptions can help explain what your Steenberg aircon is doing without asking you to identify a fault or component.',
  },
  '/aircon-repair-stonehurst-security-estate-tokai': {
    heading: 'What needs a closer look?',
    intro: "Start with the symptom that prompted you to contact us, whether it's a noise, water, or disappointing cooling. Add anything else you've noticed about your Stonehurst aircon.",
  },
  '/aircon-repair-tokai': {
    heading: 'Cooling less — or doing something unexpected?',
    intro: "Your aircon may still work, just not as it should. Tell us what feels different at your Tokai property, whether it involves comfort, sound, water, or the unit's response.",
  },
  '/aircon-repair-zwaanswyk': {
    heading: 'What changed — and when did you notice?',
    intro: 'Start with the difference between normal operation and what happens now. Tell us about your Zwaanswyk aircon, using the descriptions below if they help explain the issue.',
  },

  // Peninsula / False Bay
  '/aircon-repair-capri-village-fish-hoek': {
    heading: 'Does the problem happen every time?',
    intro: "Some faults are easy to notice; others come and go. Tell us what your Capri Village aircon does, how often it happens, and whether you've noticed a pattern.",
  },
  '/aircon-repair-clovelly': {
    heading: 'Does it work for a while, then stop?',
    intro: 'Explain what happens from startup through to the problem appearing. If your Clovelly aircon has a different issue, choose the nearest description below and add the details we should know.',
  },
  '/aircon-repair-de-goede-hoop-security-estate-noordhoek': {
    heading: 'Start with the problem you can notice',
    intro: "Tell us what you see, hear, or feel when using the aircon at your De Goede Hoop property. These descriptions can help, but your problem doesn't have to fit a category.",
  },
  '/aircon-repair-glencairn': {
    heading: 'When does the problem appear?',
    intro: 'At startup, halfway through a run, or only on certain occasions? Tell us when you notice the issue with your Glencairn aircon, as well as what the unit does.',
  },
  '/aircon-repair-kalk-bay': {
    heading: 'Has the airflow or cooling changed?',
    intro: "Tell us whether the air feels weaker, warmer, or simply different from usual. If your Kalk Bay aircon has another problem, use the descriptions below to explain what you're noticing.",
  },
  '/aircon-repair-lake-michelle-security-lifestyle-estate-noordhoek': {
    heading: 'Does it work some days, but not others?',
    intro: 'Unpredictable behaviour can be frustrating to describe. Tell us what changes between a normal run and a troublesome one with your Lake Michelle aircon, or select another symptom below.',
  },
  '/aircon-repair-muizenberg': {
    heading: 'What would you like us to look at?',
    intro: "Start with the reason you're getting in touch: poor cooling, leaking, noise, or a unit that won't work. Add anything else you've noticed about your aircon in Muizenberg.",
  },
  '/aircon-repair-noordhoek': {
    heading: 'Tell us what the aircon does',
    intro: "Does it respond, cool briefly, drip, or stop without warning? Use these descriptions to explain the issue at your Noordhoek property, then add any details that aren't covered.",
  },
  '/aircon-repair-plumstead': {
    heading: 'Changed the settings, but nothing improves?',
    intro: 'Let us know what you expected the unit to do and what happens instead. You can describe the issue with your Plumstead aircon without working out which component might be involved.',
  },
  '/aircon-repair-scarborough': {
    heading: 'Has a dependable unit become unpredictable?',
    intro: 'If the aircon no longer behaves consistently, explain what changes from one use to the next. Tell us about the problem at your Scarborough property, including any symptoms that occur together.',
  },
  '/aircon-repair-st-james': {
    heading: 'Does it sound or feel different?',
    intro: "A new noise or a less comfortable room may be what first gets your attention. Describe what you've noticed with your St James aircon and whether the change happens every time.",
  },

  // Century City
  '/aircon-repair-century-city': {
    heading: "What's interrupting your comfort?",
    intro: "An aircon can be running without making the room comfortable. Choose the description that best explains the problem at your Century City home or workplace, then tell us anything else you've noticed.",
  },
  '/aircon-repair-island-club-century-city': {
    heading: 'What needs attention in your unit?',
    intro: 'When enquiring about your aircon at Island Club, describe the problem before trying to identify a part. The examples below cover cooling, water, noise, startup, and repeated stopping.',
  },
  '/aircon-repair-knightsbridge-century-city': {
    heading: 'Describe the fault before the visit',
    intro: 'When booking for Knightsbridge, tell us what the aircon does and whether the problem happens every time. You can use the examples below without needing to identify the cause yourself.',
  },

  // Northern Suburbs
  '/aircon-repair-big-bay': {
    heading: "What isn't working as it should?",
    intro: 'Is your aircon blowing without cooling, dripping indoors, or stopping unexpectedly? Pick the closest description for your Big Bay unit and add any details that make your situation different.',
  },
  '/aircon-repair-bloubergstrand': {
    heading: 'Less cooling, more noise, or something else?',
    intro: 'A small change can be enough to make the room uncomfortable. Tell us what feels different about your Bloubergstrand aircon, even if none of the descriptions below is an exact match.',
  },
  '/aircon-repair-burgundy-estate': {
    heading: 'Describe the problem in your own words',
    intro: '\u201cIt\u2019s running, but the room stays warm\u201d is a useful place to start. These examples can help you explain what has gone wrong with your Burgundy Estate aircon.',
  },
  '/aircon-repair-clara-anna-fontein-durbanville': {
    heading: 'Has the unit stopped doing its job?',
    intro: "Whether the aircon has stopped altogether or simply isn't cooling as before, describe what has changed. Use the examples below for your enquiry in Clara Anna Fontein.",
  },
  '/aircon-repair-edgemead': {
    heading: 'What makes you think something is wrong?',
    intro: "Perhaps you've noticed a wet patch, an unfamiliar sound, or a room that stays warm. Tell us what prompted your enquiry about the aircon at your Edgemead property.",
  },
  '/aircon-repair-graanendal-lifestyle-estate-durbanville': {
    heading: 'Has something changed gradually?',
    intro: 'You might notice longer cooling times or a sound that has become more obvious. Tell us what feels different about your Graanendal aircon and whether the change has been gradual or sudden.',
  },
  '/aircon-repair-loevenstein': {
    heading: 'Less air, less cooling, or both?',
    intro: 'Describe what you feel near the outlet as well as how the room feels overall. These examples can help explain a cooling problem — or another issue — with your Loevenstein aircon.',
  },
  '/aircon-repair-parklands': {
    heading: "Does it stop before you're comfortable?",
    intro: 'Tell us roughly how long the aircon runs and whether it starts again by itself. If your Parklands unit has a different problem, explain it using the descriptions below.',
  },
  '/aircon-repair-sonstraal-durbanville': {
    heading: 'Taking longer to cool the room?',
    intro: "If the aircon no longer gives the result you're used to, describe the difference. You can also tell us about leaks, unfamiliar sounds, or startup problems at your Sonstraal property.",
  },
  '/aircon-repair-sonstraal-heights-durbanville': {
    heading: 'What has the aircon stopped doing?',
    intro: "Sometimes it's easier to explain what is missing than what is wrong. Tell us whether your Sonstraal Heights unit has lost cooling, stopped responding, or developed another noticeable problem.",
  },
  '/aircon-repair-sunningdale': {
    heading: 'Still waiting for the room to cool?',
    intro: "If the unit runs but the result isn't what you expect, describe how the air feels and how long it stays on. Other problems with your Sunningdale aircon can be explained below.",
  },
  '/aircon-repair-welgemoed': {
    heading: 'Taking longer or stopping too soon?',
    intro: 'If the room never quite becomes comfortable, describe how long the aircon runs and what it does. You can also report other problems with your Welgemoed unit below.',
  },

  // Helderberg
  '/aircon-repair-de-zalze-golf-estate-somerset-west-stellenbosch-border': {
    heading: 'Is the aircon letting you down?',
    intro: "Maybe it starts normally but doesn't cool, or switches off before the room feels comfortable. Describe what happens with your De Zalze unit and when you first noticed the change.",
  },
  '/aircon-repair-erinvale-golf-estate-somerset-west': {
    heading: 'Which symptom best describes the trouble?',
    intro: "You don't have to know whether the issue is mechanical, electrical, or something else. Describe how your Erinvale aircon behaves, including any change in cooling, sound, or response.",
  },
  '/aircon-repair-gordons-bay': {
    heading: 'Switched on, but still too warm?',
    intro: "If your room no longer cools the way it used to, explain what you notice at the unit and in the space. Other aircon symptoms in Gordon's Bay can be described below too.",
  },
  '/aircon-repair-somerset-west': {
    heading: 'What sort of trouble are you having?',
    intro: "A unit that won't start is different from one that runs without cooling. Choose the description that fits your Somerset West aircon, then explain when the problem occurs.",
  },

  // Cape Winelands
  '/aircon-repair-franschhoek': {
    heading: 'Is the room still uncomfortable?',
    intro: "If you've changed the settings but the aircon still isn't doing what you expect, explain the result you're getting. These examples can help describe the problem at your Franschhoek property.",
  },
  '/aircon-repair-paarl': {
    heading: 'What is the unit showing you?',
    intro: 'If a light or message appears, share it along with what the aircon does. For a cooling, water, or noise complaint in Paarl, choose the closest description below.',
  },
  '/aircon-repair-stellenbosch': {
    heading: 'Are the settings making any difference?',
    intro: "If changing the mode or temperature doesn't seem to help, tell us what happens instead. Use the examples below to describe the problem with your Stellenbosch aircon.",
  },
  '/aircon-repair-val-de-vie-estate-paarl': {
    heading: 'How is the unit behaving now?',
    intro: 'Tell us what has changed since the aircon last worked as expected. For your Val de Vie enquiry, include any cooling, noise, water, or startup symptoms you have noticed.',
  },
};

for (const [route, problems] of Object.entries(LOCATION_PROBLEMS)) {
  if (LOCATION_PAGES[route]) {
    LOCATION_PAGES[route].problems = {
      label: problems.label ?? 'Aircon problems',
      heading: problems.heading,
      intro: problems.intro,
      items: problems.items ?? SHARED_AIRCON_PROBLEMS,
    };
  }
}

// Shared Assessment section items (Assessment component) for every aircon
// repair page — conditional wording is deliberate: checks are carried out
// "where relevant" to the reported fault, not promised on every visit.
const SHARED_AIRCON_ASSESSMENT = [
  {
    heading: 'Refrigerant circuit and operating readings',
    description: 'Where relevant to the fault, we assess the refrigerant circuit and operating readings. We explain whether further testing or leak investigation is needed before recommending refrigerant work.',
  },
  {
    heading: 'Filters, coils and airflow',
    description: 'We inspect accessible filters, coil surfaces and airflow paths as part of the assessment. If cleaning or further work is recommended, we explain what needs attention and what is included.',
  },
  {
    heading: 'Drainage, electrical connections and controls',
    description: "Depending on the symptoms, we check drainage, accessible electrical connections and the unit's response to its controls. We discuss any findings that need repair or additional investigation.",
  },
  {
    heading: 'Compressor, fans and associated components',
    description: 'Where the reported fault calls for it, we assess compressor and fan operation and test relevant components. Any proposed replacement is explained before you approve the work.',
  },
];

const SHARED_REFRIGERATION_ASSESSMENT = [
  {
    heading: 'Temperature and control response',
    description: "We review the reported temperature problem and assess the unit's response to its controls. Any displayed readings are considered alongside the operating findings before work is recommended.",
  },
  {
    heading: 'Airflow, accessible coils and door condition',
    description: 'Where relevant to the equipment, we inspect accessible airflow paths, coil surfaces and door seals. We explain any condition issues and distinguish maintenance recommendations from proposed repairs.',
  },
  {
    heading: 'Refrigerant circuit and operating readings',
    description: 'Where the fault calls for it, we assess relevant operating readings and the refrigerant circuit. We discuss any need for further testing or leak investigation before recommending refrigerant work.',
  },
  {
    heading: 'Compressor, fans and electrical components',
    description: 'We assess relevant component operation according to the reported symptoms and equipment design. Any proposed electrical or mechanical repair is explained before you approve the work.',
  },
];

// Per-page Assessment section content: an H2 and intro paragraph. Aircon
// pages share SHARED_AIRCON_ASSESSMENT; /refrigeration-repairs uses its own.
export const LOCATION_ASSESSMENT = {
  // Existing Search Console URLs
  '/aircons-installer-kuils-river': {
    heading: 'Check what supports the repair recommendation',
    intro: 'We assess the reported problem with your Kuils River aircon and explain what the checks show. You can review any proposed repair with a clear account of the findings and outstanding questions.',
  },
  '/aircons-installation-melkbosstrand': {
    heading: 'Assess the existing unit before deciding',
    intro: 'We check your existing Melkbosstrand aircon according to the reported fault. The findings are explained before a repair is proposed, including whether any further investigation is needed to define the work.',
  },
  '/aircons-installer-fish-hoek': {
    heading: 'Check the change in everyday performance',
    intro: 'We compare your description of normal operation with the complaint being assessed. At your Fish Hoek property, we explain the relevant findings and any proposed work before a repair decision is made.',
  },
  '/aircons-installer-durbanville': {
    heading: 'Let the reported fault guide the checks',
    intro: 'We assess your Durbanville aircon according to the problem you describe and the type of unit. The findings support the next recommendation, with any remaining uncertainty explained before work proceeds.',
  },
  '/aircons-installation-milnerton': {
    heading: 'Check more than whether air is moving',
    intro: 'We assess the relevant operation of your Milnerton aircon when it runs without cooling as expected. The findings guide the recommendation, with any maintenance, repair or further testing explained separately.',
  },
  '/aircons-installations-pinelands': {
    heading: 'Turn the complaint into a focused assessment',
    intro: 'We use your description to guide relevant checks on your Pinelands aircon. After the assessment, we explain what was found and whether the proposed next step involves repair, maintenance or further investigation.',
  },
  '/aircons-installer-grassy-park': {
    heading: 'Understand what the assessment reveals',
    intro: 'We check the relevant parts of your Grassy Park aircon and explain the findings in plain language. Any proposed repair comes with a reason, including whether further investigation is needed before work can be recommended.',
  },
  '/aircons-installer-lansdowne': {
    heading: 'Review the response behind the adjustments',
    intro: 'We consider how your Lansdowne aircon behaves when you change its settings. Relevant checks guide the assessment, and the findings are explained before maintenance, repairs or additional testing are recommended.',
  },
  '/aircons-installations-strandfontein': {
    heading: 'Assess the cooling complaint before recommending work',
    intro: 'We inspect relevant areas and operating conditions of your Strandfontein aircon. The findings are explained before any repair is proposed, including whether cleaning or additional investigation needs separate consideration.',
  },
  '/aircons-installer-retreat': {
    heading: "Check the unit's response and relevant components",
    intro: 'We assess how your Retreat aircon behaves when you try to operate it. The symptoms guide further checks, with the findings and any proposed repair explained before work is authorised.',
  },
  '/aircons-installer-table-view': {
    heading: 'Review why the result no longer feels right',
    intro: 'We assess your Table View aircon in relation to the performance problem you report. You receive an explanation of the relevant findings and any proposed repair, maintenance or further checks before additional work begins.',
  },
  '/aircons-installer-melkbosstrand': {
    heading: 'Assess the pattern behind the recurring complaint',
    intro: 'We consider the history of your Melkbosstrand aircon alongside the checks possible during the visit. Confirmed findings are explained separately from possible causes that still require further investigation.',
  },
  '/aircons-installer-simon-s-town': {
    heading: 'Check the reported change before choosing parts',
    intro: "We examine your Simon's Town aircon according to the issue you describe. Any component replacement is explained through the assessment findings, with further testing discussed where the cause has not yet been established.",
  },
  '/aircons-installation-wynberg': {
    heading: 'Base the repair on the assessment',
    intro: 'We examine your Wynberg aircon before setting out recommended work. The explanation covers what was checked, what needs attention and whether further investigation is required before a repair can be defined.',
  },
  '/aircons-installations-kommetjie': {
    heading: 'Establish the next step through relevant checks',
    intro: 'We assess the reported fault with your Kommetjie aircon and explain what the checks establish. If a repair cannot yet be recommended, we discuss any additional investigation needed rather than presenting a guess as a conclusion.',
  },
  '/aircons-installer-kensington': {
    heading: 'Inspect the change before proposing a fix',
    intro: 'We assess your Kensington aircon according to the noise, leak or performance change you report. The findings are explained before recommending work, rather than assuming the symptom identifies a particular failed part.',
  },
  '/refrigeration-repairs': {
    label: 'Assessment',
    heading: 'What we assess before refrigeration repairs',
    intro: 'We assess the equipment according to the temperature problem or operating fault you report. The checks depend on the unit and available access, with the findings explained before any repair or further investigation is proposed.',
    items: SHARED_REFRIGERATION_ASSESSMENT,
  },
  '/aircons-installations-camps-bay': {
    heading: 'Check performance after the unit starts',
    intro: 'Your Camps Bay aircon is assessed for the complaint you describe, not simply whether it switches on. We explain the relevant findings and any proposed repair before asking you to authorise work.',
  },
  '/aircons-installations-meadowridge': {
    heading: "Review the unit's condition and performance",
    intro: 'We assess the relevant areas of your Meadowridge aircon when comfort or operation changes. The findings are explained before work is recommended, distinguishing the reported fault from any separate maintenance concerns.',
  },
  '/aircons-installer-ridgewood': {
    heading: 'Examine the drop in cooling performance',
    intro: 'We assess the relevant operation and condition of your Ridgewood aircon when cooling becomes less effective. The findings are explained before recommending work, including whether maintenance or further investigation is proposed.',
  },
  '/aircons-installations-platterkloof': {
    heading: 'Examine the recurring operating problem',
    intro: 'We consider when the issue returns while assessing your Plattekloof aircon. You receive an explanation of confirmed findings, any checks that remain outstanding and the work being proposed next.',
  },
  '/aircons-installation-monte-vista': {
    heading: 'Examine the unit behind the controls',
    intro: 'We review how your Monte Vista aircon responds and check the areas relevant to the complaint. You receive an explanation of the findings before any repair is proposed or component replacement recommended.',
  },

  // Atlantic Seaboard
  '/aircon-repair-alphen-estate-constantia': {
    heading: 'What we examine before recommending work',
    intro: 'Your Alphen Estate assessment starts with the problem you report. We check the relevant parts of the aircon and explain what the findings support before recommending repairs or further investigation.',
  },
  '/aircon-repair-avignon-security-estate-hout-bay': {
    heading: 'A closer look at the affected system',
    intro: 'We assess your Avignon Estate aircon with the reported symptoms in mind. The checks depend on the unit and the complaint, with any access limits or further testing explained along the way.',
  },
  '/aircon-repair-bakoven': {
    heading: 'Look beyond whether the unit switches on',
    intro: 'Starting the aircon is only part of understanding the complaint. At your Bakoven assessment, we review its operation and inspect the relevant areas before discussing what work is justified.',
  },
  '/aircon-repair-bantry-bay': {
    heading: 'Check the operation behind the symptom',
    intro: 'A sound, drip or change in cooling gives us a starting point. We assess the relevant parts of your Bantry Bay aircon and explain what we find, including anything that needs another check.',
  },
  '/aircon-repair-bergendal-security-estate-hout-bay': {
    heading: 'Relevant checks before a repair decision',
    intro: 'We use your description of the problem to guide the assessment at Bergendal Estate. From airflow to component operation, the checks are selected for the unit and the fault being investigated.',
  },
  '/aircon-repair-clifton': {
    heading: 'Look at the unit, not just the complaint',
    intro: 'Your description sets the direction for the visit, but the aircon still needs examining. We check the relevant areas at your Clifton property and explain what the assessment shows before recommending work.',
  },
  '/aircon-repair-fresnaye': {
    heading: 'Check what happens after startup',
    intro: 'We consider how your Fresnaye aircon behaves once it begins running, not only whether it turns on. The reported symptoms guide further checks, and we explain what those checks establish.',
  },
  '/aircon-repair-green-point': {
    heading: 'Understand what supports the recommendation',
    intro: 'Before proposing work on your Green Point aircon, we assess the reported problem. We explain what was checked, what was found and how those findings relate to the repair being recommended.',
  },
  '/aircon-repair-hanging-meadows-security-estate-hout-bay': {
    heading: 'Check the relevant parts of the system',
    intro: 'Your Hanging Meadows aircon is assessed according to its symptoms and accessible components. We explain the findings and flag anything that needs further access, additional testing or a separate decision before work proceeds.',
  },
  '/aircon-repair-hout-bay': {
    heading: 'Find out what the checks actually show',
    intro: 'We assess your Hout Bay aircon before recommending a repair. You receive an explanation of the relevant findings, including which issues have been established and whether anything needs more investigation.',
  },
  '/aircon-repair-kenrock-security-estate-hout-bay': {
    heading: 'Understand both the checks and the findings',
    intro: 'We explain the relevant assessment work on your KenRock Estate aircon, not just the proposed remedy. If further investigation is needed, that is made clear before you decide what work to authorise.',
  },
  '/aircon-repair-llandudno': {
    heading: 'Assess the unit before planning the repair',
    intro: 'We examine the reported problem with your Llandudno aircon and explain what the assessment supports. You can then review the proposed work with a clearer understanding of what has — and has not — been established.',
  },
  '/aircon-repair-mouille-point': {
    heading: 'Examine the operation behind the noise',
    intro: 'We consider when and where the sound occurs while assessing your Mouille Point aircon. Relevant checks are carried out where possible, and we explain whether the noise has been observed or needs further investigation.',
  },
  '/aircon-repair-ruyteplaats-security-estate-hout-bay': {
    heading: 'Separate confirmed findings from further questions',
    intro: 'We explain what the assessment of your Ruyteplaats aircon has established. Where a check is limited or more investigation is needed, we make that distinction before setting out the proposed work.',
  },
  '/aircon-repair-sea-point': {
    heading: 'Understand why the work is being proposed',
    intro: 'We assess your Sea Point aircon before discussing repairs. You receive an explanation of what needs attention and the checks supporting that recommendation, so you can review the work rather than just its price.',
  },
  '/aircon-repair-stoneybrook-security-estate-hout-bay': {
    heading: 'Assess an occasional fault with care',
    intro: 'We consider when the problem appears while checking your Stoneybrook aircon. If the symptom is absent during the visit, we explain what has been established and what may need another investigation.',
  },
  '/aircon-repair-three-anchor-bay': {
    heading: 'Review the performance, not just the setting',
    intro: 'We assess how your Three Anchor Bay aircon operates in relation to the complaint. The relevant findings are explained before any work is proposed, including whether maintenance or additional investigation is needed.',
  },
  '/aircon-repair-tierboskloof-security-estate-hout-bay': {
    heading: 'Understand the assessment and its limits',
    intro: 'We inspect the relevant areas of your Tierboskloof aircon and explain what the visit establishes. If access or intermittent symptoms prevent a complete conclusion, we discuss that before recommending further work.',
  },

  // City Bowl / CBD
  '/aircon-repair-bo-kaap': {
    heading: 'Check how the unit starts and runs',
    intro: 'At your Bo-Kaap assessment, we consider what happens when the aircon starts and during operation. Further checks depend on the symptoms, with the findings explained before any repair is proposed.',
  },
  '/aircon-repair-devils-peak-estate': {
    heading: 'Examine the change in cooling performance',
    intro: "When the aircon runs without the expected result, we assess the relevant operating conditions. At your Devil's Peak Estate property, we explain the checks completed and what the findings mean for the proposed work.",
  },
  '/aircon-repair-gardens': {
    heading: 'Assess the response, not just the display',
    intro: 'We review how your Gardens aircon responds to its controls and check the areas relevant to the complaint. You receive an explanation of the findings, including whether additional investigation is needed.',
  },
  '/aircon-repair-higgovale': {
    heading: 'Look into the problem between restarts',
    intro: 'If restarting temporarily changes the behaviour, we include that history in the assessment. We check your Higgovale aircon and explain what can be established rather than treating the restart itself as a diagnosis.',
  },
  '/aircon-repair-oranjezicht': {
    heading: 'Examine more than the visible symptom',
    intro: 'A wet patch or change in operation tells us where to begin, not which repair to promise. We assess your Oranjezicht aircon and explain the findings before discussing the work being recommended.',
  },
  '/aircon-repair-tamboerskloof': {
    heading: 'Inspect before deciding on the remedy',
    intro: 'A change in sound, water or response gives the assessment a starting point. We check the relevant areas of your Tamboerskloof aircon and explain the findings before recommending parts or repair work.',
  },
  '/aircon-repair-v-a-waterfront': {
    heading: 'Know what the assessment involves',
    intro: 'We review the reported issue and relevant access arrangements at your V&A Waterfront property. After checking the aircon, we explain the findings and scope of any proposed work before discussing repair arrangements.',
  },
  '/aircon-repair-vredehoek': {
    heading: 'Check what can be confirmed today',
    intro: 'If the aircon behaves differently between uses, we include that history in your Vredehoek assessment. We distinguish observed findings from unresolved possibilities and explain whether further investigation is recommended.',
  },

  // Southern Suburbs / Constantia Valley
  '/aircon-repair-bergvliet': {
    heading: 'Find out what needs attention',
    intro: 'Rather than starting with a replacement part, we assess your Bergvliet aircon and its operation. We explain the findings and distinguish recommended repairs from any additional maintenance being proposed.',
  },
  '/aircon-repair-bishopscourt': {
    heading: 'Check each affected unit on its own merits',
    intro: 'If several aircons need attention at your Bishopscourt property, we assess the reported issues for each. The findings and any proposed work are explained separately rather than assuming every unit has the same problem.',
  },
  '/aircon-repair-claremont': {
    heading: 'Check before choosing what to replace',
    intro: 'We assess the relevant parts of your Claremont aircon before recommending replacement components. You can review the explanation and proposed work, rather than being asked to approve a part without understanding the reason.',
  },
  '/aircon-repair-constantia': {
    heading: 'Match the checks to the complaint',
    intro: 'A cooling problem, water leak and startup failure call for different lines of investigation. We assess your Constantia aircon according to the reported issue and explain the findings before discussing any proposed repair.',
  },
  '/aircon-repair-dreyersdal-bergvliet-area': {
    heading: 'From your description to relevant checks',
    intro: "We start with what you've noticed, then assess the appropriate areas of your Dreyersdal aircon. The findings are explained in everyday language, including any reason for additional testing before a repair can be recommended.",
  },
  '/aircon-repair-high-constantia-security-estate': {
    heading: 'Review startup and the checks that follow',
    intro: "We begin with the response you've reported from your High Constantia aircon. Relevant inspections and tests follow from that complaint, with the findings and any limitations explained before further work is proposed.",
  },
  '/aircon-repair-kenilworth': {
    heading: 'Check the gap between setting and performance',
    intro: 'We review how your Kenilworth aircon operates in relation to the complaint you describe. The assessment focuses on relevant checks, with the findings explained before a repair recommendation is made.',
  },
  '/aircon-repair-kirstenhof': {
    heading: 'Investigate the startup or shutdown complaint',
    intro: 'Whether the unit struggles to start or stops during use, we assess the relevant operation. Your Kirstenhof assessment includes an explanation of the findings and any additional checks needed before recommending a repair.',
  },
  '/aircon-repair-marina-da-gama-muizenberg': {
    heading: 'Different symptoms guide different checks',
    intro: 'Your Marina da Gama assessment follows the problem you report, whether it involves cooling, water or unexpected stops. We explain which areas were examined and what the findings mean before recommending work.',
  },
  '/aircon-repair-newlands': {
    heading: 'Look beyond lights and airflow',
    intro: 'We assess the relevant operation of your Newlands aircon in light of the cooling complaint. The findings are explained before work is recommended, rather than assuming a running unit is working as intended.',
  },
  '/aircon-repair-rondebosch': {
    heading: 'Use the fault history to guide the checks',
    intro: 'Whether the change was sudden or gradual, we consider that history during your Rondebosch assessment. We examine the relevant parts of the aircon and explain the findings, including anything that needs further investigation.',
  },
  '/aircon-repair-rondebosch-oval-estate': {
    heading: 'Clear checks before a parts recommendation',
    intro: 'We assess your aircon at Rondebosch Oval before recommending replacement components. The explanation covers what was found, why any part is being proposed and whether further investigation is needed first.',
  },
  '/aircon-repair-silverhurst-security-estate-constantia': {
    heading: 'Review the condition and operation together',
    intro: 'Your description of normal performance helps frame the assessment of your Silverhurst aircon. We inspect relevant areas and explain the findings before distinguishing proposed repairs from maintenance or additional investigation.',
  },
  '/aircon-repair-silvertree-estate-tokai': {
    heading: 'Know which areas need attention',
    intro: 'We assess the reported issue with your Silvertree Estate aircon and explain the relevant findings. Any proposed work is described clearly, including whether it addresses the complaint or is a separate maintenance recommendation.',
  },
  '/aircon-repair-steenberg': {
    heading: 'Technical checks, explained without the jargon',
    intro: "You don't need to understand component names to follow the recommendation. We assess your Steenberg aircon and explain what was checked, what needs attention and whether anything remains uncertain.",
  },
  '/aircon-repair-stonehurst-security-estate-tokai': {
    heading: 'A clear account of what was checked',
    intro: 'We explain the relevant inspections and findings from your Stonehurst aircon assessment. You can review the proposed work knowing what supports the recommendation and whether any testing or access limitations remain.',
  },
  '/aircon-repair-tokai': {
    heading: 'Check before committing to replacement parts',
    intro: 'We assess your Tokai aircon before proposing components or repairs. You receive an explanation of the findings behind the recommendation, along with any further checks required before the work can be defined.',
  },
  '/aircon-repair-zwaanswyk': {
    heading: 'Relevant checks for the change you reported',
    intro: 'We assess your Zwaanswyk aircon with its recent behaviour in mind. You receive an explanation of the checks completed and what they show before any repair, maintenance or further investigation is recommended.',
  },

  // Peninsula / False Bay
  '/aircon-repair-capri-village-fish-hoek': {
    heading: 'Assess the unit alongside its fault history',
    intro: 'Your description matters when a problem comes and goes. We consider that history while checking your Capri Village aircon and explain what is confirmed, what remains uncertain and whether further investigation is proposed.',
  },
  '/aircon-repair-clovelly': {
    heading: 'Review what happens during operation',
    intro: 'If the fault appears after the unit has been running, tell us the pattern. We consider it during your Clovelly assessment and explain what can be established through the checks carried out.',
  },
  '/aircon-repair-de-goede-hoop-security-estate-noordhoek': {
    heading: 'What we inspect during the assessment',
    intro: 'We review the reported fault and inspect the relevant areas of your De Goede Hoop aircon. If something cannot be reached or fully tested during the visit, we explain the limitation and proposed next step.',
  },
  '/aircon-repair-glencairn': {
    heading: 'Check the unit with its history in mind',
    intro: 'A fault that appears occasionally may not be present throughout a visit. We consider your description while assessing the Glencairn unit and distinguish confirmed findings from issues that need further investigation.',
  },
  '/aircon-repair-kalk-bay': {
    heading: 'Examine airflow and the reported symptoms',
    intro: 'If airflow or cooling has changed, we assess the relevant parts of your Kalk Bay unit. We explain any visible condition issues and operating findings before discussing maintenance, repairs or further testing.',
  },
  '/aircon-repair-lake-michelle-security-lifestyle-estate-noordhoek': {
    heading: 'Check what can be established during the visit',
    intro: 'If your Lake Michelle aircon behaves inconsistently, we consider its history alongside the checks available. We explain confirmed findings separately from possible causes that still need investigation.',
  },
  '/aircon-repair-muizenberg': {
    heading: 'Get the findings before making the decision',
    intro: 'We assess your Muizenberg aircon and explain what needs attention. You can review any proposed repair knowing which checks support it and whether additional investigation or access is required.',
  },
  '/aircon-repair-noordhoek': {
    heading: 'Relevant checks for the problem you report',
    intro: 'We examine your Noordhoek aircon according to the symptoms and unit type. After the assessment, we explain what was found and whether the next step is a repair, maintenance or further investigation.',
  },
  '/aircon-repair-plumstead': {
    heading: "Check what the adjustments haven't explained",
    intro: 'We consider what you have already noticed while assessing your Plumstead aircon. Relevant checks help establish the next recommendation, with findings explained before any repair or additional work is proposed.',
  },
  '/aircon-repair-scarborough': {
    heading: 'Investigate the change in reliability',
    intro: 'We consider the operating history of your Scarborough aircon alongside relevant inspections and tests. The findings are explained clearly, including whether the problem was present and what further checks may be needed.',
  },
  '/aircon-repair-st-james': {
    heading: "Look into the difference you've noticed",
    intro: 'We assess the relevant parts of your St James aircon when its sound or performance changes. After the checks, we discuss the findings and explain whether repair, maintenance or further investigation is proposed.',
  },

  // Century City
  '/aircon-repair-century-city': {
    heading: 'Know what has been checked',
    intro: 'Whether the aircon serves a home or workspace in Century City, we explain the relevant checks and findings. Any proposed repair is discussed alongside the work needed and any practical access requirements.',
  },
  '/aircon-repair-island-club-century-city': {
    heading: 'Assessment with access requirements in mind',
    intro: 'We check the relevant areas of your Island Club aircon within the access available. If further access or another visit is needed to complete an investigation, we explain that before proposing additional work.',
  },
  '/aircon-repair-knightsbridge-century-city': {
    heading: 'Know the scope of the assessment',
    intro: 'We inspect the relevant areas of your Knightsbridge aircon and discuss the findings. Any restrictions affecting access or testing are explained, so the proposed repair is not presented as more certain than the assessment allows.',
  },

  // Northern Suburbs
  '/aircon-repair-big-bay': {
    heading: 'Assess first. Recommend work afterwards.',
    intro: 'Your Big Bay aircon is checked according to its symptoms and design. We discuss what the assessment establishes before recommending work, including whether more investigation is needed to reach a conclusion.',
  },
  '/aircon-repair-bloubergstrand': {
    heading: 'Examine what has changed in operation',
    intro: "We review the change you've noticed with your Bloubergstrand aircon, then carry out relevant checks. You receive an explanation of the findings rather than a recommendation based only on the initial description.",
  },
  '/aircon-repair-burgundy-estate': {
    heading: 'Understand what the assessment includes',
    intro: 'We explain which parts of your Burgundy Estate aircon need checking and why. If access restrictions or an intermittent fault limit what can be established, we make that clear before proposing the next step.',
  },
  '/aircon-repair-clara-anna-fontein-durbanville': {
    heading: 'An assessment shaped by the reported fault',
    intro: 'We check your Clara Anna Fontein aircon according to the issue you describe. The assessment may cover airflow, controls or component operation, with the scope guided by the unit and its symptoms.',
  },
  '/aircon-repair-edgemead': {
    heading: 'Check the evidence before recommending parts',
    intro: 'A replacement recommendation should come with an explanation. We assess your Edgemead aircon and discuss the findings supporting the proposed work, along with any checks that remain outstanding.',
  },
  '/aircon-repair-graanendal-lifestyle-estate-durbanville': {
    heading: 'Give the change in performance a closer look',
    intro: "We use the difference you've noticed to guide the assessment of your Graanendal aircon. After the relevant checks, we explain whether repair, maintenance or further investigation is being recommended.",
  },
  '/aircon-repair-loevenstein': {
    heading: 'Check the airflow and operating complaint',
    intro: 'We assess the relevant condition and operation of your Loevenstein aircon when airflow or cooling changes. Any maintenance recommendation is explained separately from component repairs or further fault investigation.',
  },
  '/aircon-repair-parklands': {
    heading: 'Assess the repeated stopping problem',
    intro: 'We review the running pattern you describe and check the relevant areas of your Parklands aircon. If the complaint cannot be reproduced during the visit, we explain what remains unresolved and any proposed next step.',
  },
  '/aircon-repair-sonstraal-durbanville': {
    heading: 'Examine the change in cooling time',
    intro: 'We assess the relevant operating conditions when your Sonstraal aircon takes longer to cool. The findings are explained before work is proposed, with any need for cleaning, repairs or further testing distinguished clearly.',
  },
  '/aircon-repair-sonstraal-heights-durbanville': {
    heading: 'Check the function that has changed',
    intro: 'We use your description of what the aircon no longer does to guide the assessment. At your Sonstraal Heights property, we explain the relevant checks and what they establish before recommending the next step.',
  },
  '/aircon-repair-sunningdale': {
    heading: "Check why running isn't bringing comfort",
    intro: 'We assess your Sunningdale aircon according to the cooling problem you describe. Relevant inspections and operating checks guide the findings, which are explained before repairs or other work are proposed.',
  },
  '/aircon-repair-welgemoed': {
    heading: 'Assess the cooling and stopping pattern',
    intro: "We consider how long your Welgemoed aircon runs and the result you're getting. Relevant checks guide the findings, with any repair or further investigation explained before additional work is agreed.",
  },

  // Helderberg
  '/aircon-repair-de-zalze-golf-estate-somerset-west-stellenbosch-border': {
    heading: 'A clearer basis for the repair decision',
    intro: 'We assess your De Zalze aircon before setting out the recommended work. The aim is to explain what needs attention, why it is being recommended and whether any further investigation is required.',
  },
  '/aircon-repair-erinvale-golf-estate-somerset-west': {
    heading: 'See what needs attention before work starts',
    intro: 'We inspect the relevant parts of your Erinvale aircon and explain what we find. Any proposed repair is set out clearly, with further investigation distinguished from work that can already be recommended.',
  },
  '/aircon-repair-gordons-bay': {
    heading: 'Review the operation behind weaker cooling',
    intro: "We assess the relevant airflow, controls and operating conditions of your Gordon's Bay aircon. The exact checks depend on the symptoms and unit, with any recommended work explained before you approve it.",
  },
  '/aircon-repair-somerset-west': {
    heading: 'Choose the checks before choosing the repair',
    intro: 'The symptoms and unit guide the assessment of your Somerset West aircon. We inspect and test relevant areas, then explain what the findings support before recommending work or additional investigation.',
  },

  // Cape Winelands
  '/aircon-repair-franschhoek': {
    heading: 'Look into the shortfall in cooling',
    intro: 'If your aircon is no longer keeping the room comfortable, we assess its operation and relevant components. Your Franschhoek assessment includes an explanation of the findings before any repair work is put forward.',
  },
  '/aircon-repair-paarl': {
    heading: 'Check the unit behind the displayed message',
    intro: 'Any message or light you report is considered alongside the assessment of your Paarl aircon. We explain the relevant checks and findings rather than recommending a replacement solely from the information supplied at booking.',
  },
  '/aircon-repair-stellenbosch': {
    heading: 'Examine the response to the selected settings',
    intro: 'We review the operating complaint and carry out relevant checks on your Stellenbosch aircon. The assessment findings are explained before any repair is recommended, including whether further investigation is needed.',
  },
  '/aircon-repair-val-de-vie-estate-paarl': {
    heading: 'Inspect the system before recommending work',
    intro: 'We assess your Val de Vie aircon according to its symptoms and accessible components. The findings are explained before a repair is proposed, including whether more testing or further access is required.',
  },
};

for (const [route, assessment] of Object.entries(LOCATION_ASSESSMENT)) {
  if (LOCATION_PAGES[route]) {
    LOCATION_PAGES[route].assessment = {
      label: assessment.label ?? 'Assessment',
      heading: assessment.heading,
      intro: assessment.intro,
      items: assessment.items ?? SHARED_AIRCON_ASSESSMENT,
    };
  }
}

// Shared Process section steps (Process component) for every aircon repair
// page — matching the existing image sequence: inspect, test, quote, approve.
const SHARED_AIRCON_PROCESS = [
  {
    heading: 'Discuss the problem and inspect',
    description: "We ask what has changed, then inspect the areas relevant to the complaint. Let us know about previous work or anything unusual you've noticed.",
  },
  {
    heading: 'Test and explain the findings',
    description: 'We carry out relevant checks and explain what they establish. If the problem needs further investigation, we discuss that before proposing additional work.',
  },
  {
    heading: 'Provide the repair quote',
    description: 'Once the proposed repair is defined, we provide a written quote explaining the work and cost. You can ask questions before deciding whether to proceed.',
  },
  {
    heading: 'Get your approval before repairs',
    description: 'Repair work starts after you approve the quote. If additional work becomes necessary, we explain the change and seek your agreement before proceeding.',
  },
];

const SHARED_REFRIGERATION_PROCESS = [
  {
    heading: 'Discuss the equipment and symptoms',
    description: 'We ask about the unit, the problem and when it began, then inspect the relevant areas. Share any messages, temperature changes or previous repair details.',
  },
  {
    heading: 'Assess and explain',
    description: 'We carry out relevant checks and explain what they establish. If further investigation is needed, we discuss the proposed next step before additional work.',
  },
  {
    heading: 'Provide the repair quote',
    description: 'Once the proposed repair is defined, we provide a written quote explaining the work and cost. You have the opportunity to ask questions before deciding.',
  },
  {
    heading: 'Obtain approval before repairs',
    description: 'We start repair work after you approve the quote. If the scope changes, we explain the additional work and seek your agreement before proceeding.',
  },
];

// Per-page Process section content: an H2 and intro paragraph. Aircon pages
// share SHARED_AIRCON_PROCESS; /refrigeration-repairs uses its own steps.
export const LOCATION_PROCESS = {
  // Existing Search Console URLs
  '/aircons-installer-kuils-river': {
    heading: 'Review the repair before work begins',
    intro: 'We assess your Kuils River aircon and explain the proposed work. You can ask questions about the quote before deciding whether to authorise repairs.',
  },
  '/aircons-installation-melkbosstrand': {
    heading: 'A clear process for your existing aircon',
    intro: 'We assess the reported problem with your existing Melkbosstrand unit and explain the findings before discussing a repair quote and asking for approval.',
  },
  '/aircons-installer-fish-hoek': {
    heading: 'Follow the repair from enquiry to approval',
    intro: 'Tell us what has changed with your Fish Hoek aircon. We assess it, explain the recommendation and discuss the quote before you decide.',
  },
  '/aircons-installer-durbanville': {
    heading: 'An assessment before the repair decision',
    intro: 'We assess your Durbanville aircon according to the complaint and explain the findings. You review the proposed work and quote before repairs begin.',
  },
  '/aircons-installation-milnerton': {
    heading: 'Understand the repair before authorising it',
    intro: 'Tell us how your Milnerton aircon is performing. We assess the complaint, explain the recommendation and discuss the proposed cost before repairs begin.',
  },
  '/aircons-installations-pinelands': {
    heading: 'Know what the assessment leads to',
    intro: 'We explain what has been established about your Pinelands aircon, then discuss the proposed next step and cost before seeking approval for more work.',
  },
  '/aircons-installer-grassy-park': {
    heading: 'Start with your description of the problem',
    intro: 'You explain what your Grassy Park aircon does; we assess the complaint and discuss the findings before proposing repair work for your approval.',
  },
  '/aircons-installer-lansdowne': {
    heading: 'Move from repeated adjustments to a decision',
    intro: 'We assess the complaint with your Lansdowne aircon and discuss the findings. Any proposed repair and its cost are explained before work starts.',
  },
  '/aircons-installations-strandfontein': {
    heading: 'Understand the recommendation before committing',
    intro: 'Your Strandfontein assessment is followed by an explanation of the findings. We discuss the proposed repair and cost before asking you to approve work.',
  },
  '/aircons-installer-retreat': {
    heading: 'Know what follows the response checks',
    intro: 'We assess your Retreat aircon and explain the findings before discussing the proposed repair and cost. You decide whether to authorise the work.',
  },
  '/aircons-installer-table-view': {
    heading: 'From the performance complaint to an agreed repair',
    intro: 'We assess your Table View aircon, explain what we find and discuss the proposed work and cost before asking you to authorise the repair.',
  },
  '/aircons-installer-melkbosstrand': {
    heading: 'Understand the next step for recurring symptoms',
    intro: 'We discuss what the assessment of your Melkbosstrand aircon establishes, including whether further investigation is needed before a repair can be proposed.',
  },
  '/aircons-installer-simon-s-town': {
    heading: 'Understand the findings before approving repairs',
    intro: "We assess the reported change with your Simon's Town aircon and explain the recommendation. The repair quote is yours to review before work begins.",
  },
  '/aircons-installation-wynberg': {
    heading: 'Know what is proposed before work starts',
    intro: 'We explain the findings from your Wynberg assessment and provide a quote for defined repair work. You decide whether to authorise the proposed repair.',
  },
  '/aircons-installations-kommetjie': {
    heading: 'Agree on the next stage after assessment',
    intro: 'We explain what the Kommetjie assessment establishes and whether repair or further investigation is proposed. Additional work is discussed before you authorise it.',
  },
  '/aircons-installer-kensington': {
    heading: 'Know why the work is being proposed',
    intro: 'We explain the findings from your Kensington aircon assessment and discuss the recommended repair, including its quoted cost, before seeking your agreement.',
  },
  '/refrigeration-repairs': {
    label: 'Repair process',
    heading: 'What happens before refrigeration repairs begin',
    intro: "Tell us about the equipment and the problem you've noticed. We assess the complaint, explain the findings and discuss any proposed repair before you decide whether to proceed.",
    items: SHARED_REFRIGERATION_PROCESS,
  },
  '/aircons-installations-camps-bay': {
    heading: 'Understand the work behind the recommendation',
    intro: 'We assess your Camps Bay aircon and discuss the proposed remedy. You can review the scope and cost before agreeing to repair work.',
  },
  '/aircons-installations-meadowridge': {
    heading: 'From the complaint to an explained quote',
    intro: 'We assess your Meadowridge aircon and discuss the findings, giving you an explanation of the proposed work before you consider the repair price.',
  },
  '/aircons-installer-ridgewood': {
    heading: 'A clear proposal after the cooling assessment',
    intro: 'We explain the findings for your Ridgewood aircon, then discuss any proposed work and quote so you can make the repair decision with the details.',
  },
  '/aircons-installations-platterkloof': {
    heading: 'A clear next step for recurring trouble',
    intro: 'We assess the reported pattern with your Plattekloof aircon and explain the findings before discussing any repair or further investigation being proposed.',
  },
  '/aircons-installation-monte-vista': {
    heading: "From the unit's response to a repair proposal",
    intro: 'We assess the complaint with your Monte Vista aircon and explain what the checks show before recommending work for you to consider.',
  },

  // Atlantic Seaboard
  '/aircon-repair-alphen-estate-constantia': {
    heading: 'From your first enquiry to repair approval',
    intro: 'Tell us what is happening with your Alphen Estate aircon. We explain the findings and proposed cost before you decide on repairs.',
  },
  '/aircon-repair-avignon-security-estate-hout-bay': {
    heading: 'Know what happens next',
    intro: 'When booking at Avignon Estate, share the symptoms and access details. The steps below explain how the visit progresses towards a repair decision.',
  },
  '/aircon-repair-bakoven': {
    heading: 'A repair process you can follow',
    intro: "You don't need to arrive with a diagnosis. Describe your Bakoven aircon problem, and we explain the checks, findings and proposed work.",
  },
  '/aircon-repair-bantry-bay': {
    heading: 'Understand the work before agreeing',
    intro: "Your Bantry Bay enquiry starts with what you've noticed. We assess the complaint and discuss the repair proposal before asking for approval.",
  },
  '/aircon-repair-bergendal-security-estate-hout-bay': {
    heading: 'Clear steps before repair work begins',
    intro: 'We keep you informed as your Bergendal Estate aircon is assessed. You review the proposed work and cost before deciding whether to proceed.',
  },
  '/aircon-repair-clifton': {
    heading: 'An explanation before a repair bill',
    intro: 'We assess your Clifton aircon and discuss the proposed remedy. You see the repair quote before deciding whether to authorise the work.',
  },
  '/aircon-repair-fresnaye': {
    heading: 'Make the next step an informed one',
    intro: 'Your Fresnaye assessment leads to an explanation, not an automatic repair. We discuss what is proposed and its cost before seeking approval.',
  },
  '/aircon-repair-green-point': {
    heading: 'Know the work as well as the price',
    intro: 'Your Green Point repair quote follows an explanation of the findings. We discuss what is proposed so you can review more than the total.',
  },
  '/aircon-repair-hanging-meadows-security-estate-hout-bay': {
    heading: 'A clear proposal after the assessment',
    intro: 'We explain what the visit to your Hanging Meadows property establishes, including whether a repair or further investigation is being proposed.',
  },
  '/aircon-repair-hout-bay': {
    heading: 'A repair visit with clear decision points',
    intro: 'We explain the findings from your Hout Bay assessment before proposing work. You review the repair quote and decide whether to authorise it.',
  },
  '/aircon-repair-kenrock-security-estate-hout-bay': {
    heading: 'Know the reason for the recommendation',
    intro: 'We explain the findings from your KenRock Estate aircon assessment and discuss any proposed work before you decide whether to approve the quote.',
  },
  '/aircon-repair-llandudno': {
    heading: 'Decide after the findings are explained',
    intro: 'Your Llandudno assessment gives us a basis for discussing the next step. We explain any repair proposal and cost before you commit.',
  },
  '/aircon-repair-mouille-point': {
    heading: 'Discuss the symptoms, then review the findings',
    intro: 'We consider your description during the Mouille Point assessment. Afterwards, we explain what was established and the next work being proposed.',
  },
  '/aircon-repair-ruyteplaats-security-estate-hout-bay': {
    heading: 'Know what is confirmed before deciding',
    intro: 'We explain the findings for your Ruyteplaats aircon, including any unresolved questions. The next work and its cost are discussed before approval.',
  },
  '/aircon-repair-sea-point': {
    heading: "Know what you're paying to have repaired",
    intro: 'Your Sea Point repair proposal follows an explanation of the assessment findings. We discuss the work and quoted cost before you authorise repairs.',
  },
  '/aircon-repair-stoneybrook-security-estate-hout-bay': {
    heading: 'Know the next step with an occasional fault',
    intro: 'We explain what can be established about your Stoneybrook aircon and discuss any proposed repair or further investigation before you authorise additional work.',
  },
  '/aircon-repair-three-anchor-bay': {
    heading: 'Review the findings and the proposed remedy',
    intro: 'We explain the assessment of your Three Anchor Bay aircon, including the work recommended and its cost, before you decide whether to approve repairs.',
  },
  '/aircon-repair-tierboskloof-security-estate-hout-bay': {
    heading: 'Know the findings before agreeing to more work',
    intro: 'We discuss what your Tierboskloof aircon assessment establishes. Any proposed repair or further investigation is explained before you decide on the next stage.',
  },

  // City Bowl / CBD
  '/aircon-repair-bo-kaap': {
    heading: 'Inspection before a repair commitment',
    intro: 'We start with how your Bo-Kaap aircon behaves. Relevant checks and an explanation come before you decide whether to authorise repairs.',
  },
  '/aircon-repair-devils-peak-estate': {
    heading: 'Start with the complaint, not a parts list',
    intro: "Describe the problem with your Devil's Peak Estate aircon. The assessment guides the recommendation, which we explain before asking you to approve work.",
  },
  '/aircon-repair-gardens': {
    heading: 'Find out what the visit establishes',
    intro: 'We review your Gardens aircon complaint and explain the findings. If more investigation is needed, we discuss that before proposing additional work.',
  },
  '/aircon-repair-higgovale': {
    heading: 'Move beyond another restart',
    intro: 'Tell us how restarting affects your Higgovale aircon. We assess the complaint and explain the next step before you decide on proposed work.',
  },
  '/aircon-repair-oranjezicht': {
    heading: 'Understand the recommendation behind the quote',
    intro: 'We discuss what your Oranjezicht assessment reveals before presenting a repair proposal. You can consider the explanation and price together before deciding.',
  },
  '/aircon-repair-tamboerskloof': {
    heading: 'A clear process after something changes',
    intro: 'Tell us what first drew your attention to the Tamboerskloof aircon. We assess the complaint and explain the proposed next step before work proceeds.',
  },
  '/aircon-repair-v-a-waterfront': {
    heading: 'Agree on the repair and its arrangements',
    intro: 'We explain the proposed work at your V&A Waterfront property so you can consider the repair quote and discuss practical arrangements before authorising it.',
  },
  '/aircon-repair-vredehoek': {
    heading: 'Clear findings, including any open questions',
    intro: 'If your Vredehoek aircon problem comes and goes, we explain what is confirmed and discuss any proposed further investigation before additional work is authorised.',
  },

  // Southern Suburbs / Constantia Valley
  '/aircon-repair-bergvliet': {
    heading: 'First the findings, then your decision',
    intro: 'Arrange an assessment for your Bergvliet aircon and tell us what has changed. We explain the recommendation before you commit to repairs.',
  },
  '/aircon-repair-bishopscourt': {
    heading: 'Agree on the work, unit by unit',
    intro: 'If several aircons need attention at your Bishopscourt property, we explain the findings and proposed work for each affected unit.',
  },
  '/aircon-repair-claremont': {
    heading: 'Your description starts the conversation',
    intro: 'Explain what your Claremont aircon is doing. We take the enquiry through assessment, explanation and quotation before any repair is agreed.',
  },
  '/aircon-repair-constantia': {
    heading: "Know what you're being asked to approve",
    intro: 'Your Constantia repair proposal includes an explanation of the work and cost. Ask questions before deciding whether you want repairs to proceed.',
  },
  '/aircon-repair-dreyersdal-bergvliet-area': {
    heading: 'Straightforward steps, explained plainly',
    intro: "You don't need technical terms for your Dreyersdal enquiry. We discuss the symptoms, assess the unit and explain the proposed repair in everyday language.",
  },
  '/aircon-repair-high-constantia-security-estate': {
    heading: 'From startup symptoms to a work proposal',
    intro: 'Describe what happens when your High Constantia aircon turns on. We discuss the assessment findings and cost of any proposed repair.',
  },
  '/aircon-repair-kenilworth': {
    heading: 'Understand the route from complaint to repair',
    intro: 'Your description starts the Kenilworth assessment. We explain what follows from the findings, including the work and price proposed for your approval.',
  },
  '/aircon-repair-kirstenhof': {
    heading: 'A clear next step after the checks',
    intro: 'We assess your Kirstenhof aircon and explain whether repair or further investigation is proposed. Any additional work is discussed before you authorise it.',
  },
  '/aircon-repair-marina-da-gama-muizenberg': {
    heading: 'The complaint guides the process',
    intro: 'Tell us what is happening with your Marina da Gama aircon. We assess the issue and explain any proposed repair before asking you to authorise it.',
  },
  '/aircon-repair-newlands': {
    heading: 'Make the repair decision with the details',
    intro: 'We assess your Newlands aircon and explain the recommendation, including the work and cost proposed. Approval comes before repairs begin.',
  },
  '/aircon-repair-rondebosch': {
    heading: 'Your account, our checks, your decision',
    intro: 'We consider the history of your Rondebosch aircon problem, explain the assessment findings and discuss the proposed repair before you choose whether to proceed.',
  },
  '/aircon-repair-rondebosch-oval-estate': {
    heading: 'A quote that follows an explanation',
    intro: 'We assess your aircon at Rondebosch Oval and explain the recommended work. The written repair quote is yours to review before giving approval.',
  },
  '/aircon-repair-silverhurst-security-estate-constantia': {
    heading: 'Understand the work before agreeing to it',
    intro: 'We explain the findings from your Silverhurst aircon assessment and discuss the proposed repair, giving you the opportunity to review the quote and ask questions.',
  },
  '/aircon-repair-silvertree-estate-tokai': {
    heading: 'Review a defined scope of work',
    intro: 'For your Silvertree Estate aircon, we explain the proposed repair before seeking approval. You can check what is included and consider the quoted cost.',
  },
  '/aircon-repair-steenberg': {
    heading: 'No technical knowledge needed to get started',
    intro: 'Describe what your Steenberg aircon does. We handle the assessment and explain the proposed repair in language you can follow before you decide.',
  },
  '/aircon-repair-stonehurst-security-estate-tokai': {
    heading: 'See the proposal before making the commitment',
    intro: 'We explain what the Stonehurst assessment establishes, then discuss the proposed work. You can review the repair quote before deciding whether to go ahead.',
  },
  '/aircon-repair-tokai': {
    heading: 'Check, explain, quote — then seek approval',
    intro: 'We assess your Tokai aircon and discuss the recommendation. You receive a quote for proposed repair work before deciding whether you want it carried out.',
  },
  '/aircon-repair-zwaanswyk': {
    heading: 'A repair proposal you can review',
    intro: 'Your Zwaanswyk assessment is followed by an explanation of the findings. We discuss any proposed work and provide the repair quote before seeking approval.',
  },

  // Peninsula / False Bay
  '/aircon-repair-capri-village-fish-hoek': {
    heading: 'A clear next step, even with an occasional fault',
    intro: 'Tell us when your Capri Village aircon gives trouble. We explain what the visit establishes and whether repair or further investigation is proposed.',
  },
  '/aircon-repair-clovelly': {
    heading: 'Work through the problem step by step',
    intro: 'Tell us how your Clovelly aircon behaves during use. We explain the findings and discuss the next step rather than assuming a repair.',
  },
  '/aircon-repair-de-goede-hoop-security-estate-noordhoek': {
    heading: 'From booking details to an agreed repair',
    intro: 'Share the symptoms and access arrangements for your De Goede Hoop property. We assess the unit and explain the proposed work before approval.',
  },
  '/aircon-repair-glencairn': {
    heading: 'Clear communication when the fault comes and goes',
    intro: 'An occasional problem may need further investigation. We explain what your Glencairn assessment establishes and discuss the proposed next step with you.',
  },
  '/aircon-repair-kalk-bay': {
    heading: 'Check, explain and agree before repairing',
    intro: 'We assess your Kalk Bay aircon, talk through the findings and quote for the proposed repair. The decision to proceed remains yours.',
  },
  '/aircon-repair-lake-michelle-security-lifestyle-estate-noordhoek': {
    heading: 'An explanation, including what remains uncertain',
    intro: 'If your Lake Michelle fault is intermittent, we explain what has been established and discuss any further investigation before requesting approval for more work.',
  },
  '/aircon-repair-muizenberg': {
    heading: 'Review the repair before you commit',
    intro: 'We explain the findings for your Muizenberg aircon and provide a quote for defined repair work. Ask questions before deciding whether to proceed.',
  },
  '/aircon-repair-noordhoek': {
    heading: 'From the first description to the agreed work',
    intro: 'Your Noordhoek enquiry begins with the symptoms. We assess the unit, explain the findings and discuss the repair proposal before seeking your approval.',
  },
  '/aircon-repair-plumstead': {
    heading: 'Move from adjustments to an agreed plan',
    intro: 'Tell us what you have noticed with your Plumstead aircon. We assess it and explain the proposed work before asking you to review a quote.',
  },
  '/aircon-repair-scarborough': {
    heading: 'A clear next step for an unreliable unit',
    intro: 'We assess the complaint with your Scarborough aircon and explain whether repair or further investigation is proposed, so you can decide what to authorise.',
  },
  '/aircon-repair-st-james': {
    heading: 'Understand the findings before choosing the repair',
    intro: 'We discuss the change with your St James aircon, assess the unit and explain the proposed work before asking you to approve its cost.',
  },

  // Century City
  '/aircon-repair-century-city': {
    heading: 'Plan around the work being proposed',
    intro: 'We discuss your Century City aircon problem, assess the unit and explain the repair proposal so you can consider the work and arrangements.',
  },
  '/aircon-repair-island-club-century-city': {
    heading: 'Agree on the repair and the arrangements',
    intro: 'For an Island Club visit, share the fault and access details. We explain the proposed repair before discussing approval and practical arrangements.',
  },
  '/aircon-repair-knightsbridge-century-city': {
    heading: 'Know what happens before repairs begin',
    intro: 'We discuss your Knightsbridge aircon problem, carry out relevant checks and explain the proposed work. You review the quote before deciding to proceed.',
  },

  // Northern Suburbs
  '/aircon-repair-big-bay': {
    heading: 'What to expect from the repair visit',
    intro: 'From discussing the symptoms to reviewing a quote, these steps explain the process for an aircon repair enquiry in Big Bay.',
  },
  '/aircon-repair-bloubergstrand': {
    heading: 'From the reported problem to a clear proposal',
    intro: 'Describe the change in your Bloubergstrand aircon. We assess it, discuss what we find and explain any proposed repair before proceeding.',
  },
  '/aircon-repair-burgundy-estate': {
    heading: 'Keep the repair decision in your hands',
    intro: 'We explain the findings from your Burgundy Estate assessment and set out the proposed work, giving you the information to decide.',
  },
  '/aircon-repair-clara-anna-fontein-durbanville': {
    heading: 'Know the process before the visit',
    intro: 'For your Clara Anna Fontein enquiry, start with the symptoms. We explain the assessment findings and proposed repair before seeking approval.',
  },
  '/aircon-repair-edgemead': {
    heading: 'Know why the repair is recommended',
    intro: 'Before you approve work on your Edgemead aircon, we explain the findings, the proposed remedy and what the repair quote includes.',
  },
  '/aircon-repair-graanendal-lifestyle-estate-durbanville': {
    heading: 'Follow the process from enquiry to approval',
    intro: 'Tell us what has changed with your Graanendal aircon. We guide the enquiry through assessment and quotation before any repair is agreed.',
  },
  '/aircon-repair-loevenstein': {
    heading: 'Separate the findings from the proposed work',
    intro: 'We explain what the Loevenstein assessment shows, then discuss the recommended response. You can review the scope and quote before approving a repair.',
  },
  '/aircon-repair-parklands': {
    heading: 'Know what follows the stopping problem',
    intro: 'We assess the running pattern of your Parklands aircon and discuss the findings. Any repair or additional investigation is explained before you approve it.',
  },
  '/aircon-repair-sonstraal-durbanville': {
    heading: 'From changed performance to a clear next step',
    intro: 'Tell us how your Sonstraal aircon has changed. We explain the assessment findings and discuss the work and cost proposed for your approval.',
  },
  '/aircon-repair-sonstraal-heights-durbanville': {
    heading: 'Know what the next stage involves',
    intro: 'After assessing your Sonstraal Heights aircon, we explain what is proposed. You review any repair quote or additional investigation before authorising further work.',
  },
  '/aircon-repair-sunningdale': {
    heading: 'Understand the plan before repairs start',
    intro: 'Your Sunningdale assessment leads to an explanation of the findings. We discuss the proposed repair and quoted cost before asking for approval.',
  },
  '/aircon-repair-welgemoed': {
    heading: 'Understand what happens after the checks',
    intro: 'We explain the findings for your Welgemoed aircon and the next work being proposed. The cost is discussed before you decide what to approve.',
  },

  // Helderberg
  '/aircon-repair-de-zalze-golf-estate-somerset-west-stellenbosch-border': {
    heading: 'Understand the recommendation before deciding',
    intro: 'We discuss what the assessment of your De Zalze aircon reveals, then explain any proposed repair and cost before you make a decision.',
  },
  '/aircon-repair-erinvale-golf-estate-somerset-west': {
    heading: 'A defined repair before your approval',
    intro: 'We assess your Erinvale aircon and discuss what needs attention. You can review the proposed work and quote before deciding to proceed.',
  },
  '/aircon-repair-gordons-bay': {
    heading: 'Understand the proposal before work starts',
    intro: "We assess the complaint with your Gordon's Bay aircon, explain the findings and provide the proposed repair cost before asking you to proceed.",
  },
  '/aircon-repair-somerset-west': {
    heading: 'An assessment before the repair proposal',
    intro: 'We assess your Somerset West aircon according to the complaint, explain the findings and discuss any proposed repair before you decide to proceed.',
  },

  // Cape Winelands
  '/aircon-repair-franschhoek': {
    heading: 'From a cooling complaint to a repair decision',
    intro: 'Tell us how your Franschhoek aircon is performing. We explain the assessment results and any proposed work before you authorise repairs.',
  },
  '/aircon-repair-paarl': {
    heading: 'A clear explanation after the assessment',
    intro: 'Share the symptoms and any displayed message from your Paarl aircon. We assess the complaint and explain the proposed next step before additional work.',
  },
  '/aircon-repair-stellenbosch': {
    heading: 'Clear steps from assessment to approval',
    intro: 'We assess the complaint with your Stellenbosch aircon and explain the findings. Defined repair work is quoted for your review before repairs begin.',
  },
  '/aircon-repair-val-de-vie-estate-paarl': {
    heading: 'From the assessment to your repair decision',
    intro: 'We discuss the findings for your Val de Vie aircon and explain the proposed work. You review the quote before choosing whether to proceed.',
  },
};

for (const [route, process] of Object.entries(LOCATION_PROCESS)) {
  if (LOCATION_PAGES[route]) {
    LOCATION_PAGES[route].process = {
      label: process.label ?? 'Repair process',
      heading: process.heading,
      intro: process.intro,
      items: process.items ?? SHARED_AIRCON_PROCESS,
    };
  }
}

// Shared Repair options items (Repairs component) for every aircon repair
// page — matching the existing image sequence: part, clean, regas, replace.
const SHARED_AIRCON_OPTIONS = [
  {
    heading: 'Replacement parts',
    description: 'If a component needs replacing, we explain the part being proposed and include the work in the repair quote. You can review the recommendation before approving it.',
  },
  {
    heading: 'Cleaning where needed',
    description: 'If the assessment supports cleaning, we explain which areas need attention and what the work includes. Cleaning and component repairs are set out separately where both are proposed.',
  },
  {
    heading: 'Refrigerant work',
    description: 'If refrigerant work is recommended, we explain the findings and any leak investigation or repair being proposed. The quote sets out the agreed scope before work begins.',
  },
  {
    heading: 'Considering a replacement',
    description: 'If replacement is worth considering, we explain why and discuss it alongside the proposed repair. You can compare the available information before deciding what to do.',
  },
];

const SHARED_REFRIGERATION_OPTIONS = [
  {
    heading: 'Replacement components',
    description: 'If a component is recommended for replacement, we explain the proposal and include the defined work in the repair quote for your review.',
  },
  {
    heading: 'Cleaning and maintenance',
    description: 'If cleaning or maintenance is recommended, we describe the areas involved and distinguish that work from component repairs or further investigation.',
  },
  {
    heading: 'Refrigerant work',
    description: 'Where refrigerant work is proposed, we explain the findings and any further leak investigation or repair included in the scope before seeking approval.',
  },
  {
    heading: 'Considering replacement',
    description: 'If replacement is worth discussing, we explain the reasons alongside the repair proposal. You can consider the information before deciding what to do.',
  },
];

// Per-page Repair options content: an H2 and paragraph per URL.
export const LOCATION_OPTIONS = {
  // Existing Search Console URLs
  '/aircons-installer-kuils-river': {
    heading: 'Know the work before approving the quote',
    paragraph: 'We describe the recommendation for your Kuils River aircon, including the proposed scope. You can consider what is included before deciding whether to authorise repairs.',
  },
  '/aircons-installation-melkbosstrand': {
    heading: 'Consider the options for your existing unit',
    paragraph: 'We explain the work proposed for your existing Melkbosstrand aircon. You can review repair, maintenance or replacement considerations without treating them as the same decision.',
  },
  '/aircons-installer-fish-hoek': {
    heading: 'A clear recommendation for your existing aircon',
    paragraph: 'We describe the proposed work for your Fish Hoek unit and why it is being recommended. You can review the scope and quote before approving repairs.',
  },
  '/aircons-installer-durbanville': {
    heading: 'Know what the repair recommendation covers',
    paragraph: 'We explain the proposed work for your Durbanville aircon before you decide. Any separate maintenance or further investigation is identified alongside the repair proposal.',
  },
  '/aircons-installation-milnerton': {
    heading: 'Know what the proposed repair includes',
    paragraph: 'We describe the recommendation for your Milnerton aircon and its scope. Cleaning, parts and further checks are identified where they form part of the proposal.',
  },
  '/aircons-installations-pinelands': {
    heading: 'Understand the proposal after the assessment',
    paragraph: 'We describe the recommended work for your Pinelands aircon, including anything that needs further investigation. The scope is explained before you consider the repair cost.',
  },
  '/aircons-installer-grassy-park': {
    heading: 'Repair options explained in everyday language',
    paragraph: 'We discuss what is recommended for your Grassy Park aircon without leaving you to interpret a parts list. Ask questions about the scope before deciding.',
  },
  '/aircons-installer-lansdowne': {
    heading: 'Review the proposal after the checks',
    paragraph: 'We explain what is being recommended for your Lansdowne aircon and distinguish any separate maintenance. You can review the proposed work and cost before proceeding.',
  },
  '/aircons-installations-strandfontein': {
    heading: 'Review the work intended to address the complaint',
    paragraph: 'We describe the recommendation for your Strandfontein aircon following assessment. Parts, cleaning and further checks are explained where relevant to the proposed scope.',
  },
  '/aircons-installer-retreat': {
    heading: 'Know what is recommended for the response problem',
    paragraph: 'We describe the proposed next step for your Retreat aircon after assessment. Any defined repair and additional investigation are explained separately before you make a decision.',
  },
  '/aircons-installer-table-view': {
    heading: 'Consider the remedy before authorising work',
    paragraph: 'We explain the proposed work for your Table View aircon and the reason for it. You can review the scope alongside the quote before deciding.',
  },
  '/aircons-installer-melkbosstrand': {
    heading: 'Understand the next step for recurring symptoms',
    paragraph: 'We explain whether the assessment of your Melkbosstrand aircon supports a repair proposal or further investigation. You know which work is being quoted before approving it.',
  },
  '/aircons-installer-simon-s-town': {
    heading: 'Know what the proposal includes',
    paragraph: "We describe the recommendation for your Simon's Town aircon, including any separate maintenance or investigation. You can ask questions before agreeing to the proposed work.",
  },
  '/aircons-installation-wynberg': {
    heading: 'A defined proposal before you commit',
    paragraph: 'We describe the recommended work for your Wynberg aircon and distinguish it from any separate maintenance. You can consider the scope and quote before approving repairs.',
  },
  '/aircons-installations-kommetjie': {
    heading: 'Review the next step for your unit',
    paragraph: 'We describe whether your Kommetjie aircon has a repair proposal or needs further investigation. The work being quoted is explained before you authorise it.',
  },
  '/aircons-installer-kensington': {
    heading: 'Understand what the work is meant to address',
    paragraph: 'We explain the proposal for your Kensington aircon and how it relates to the assessed complaint. Separate cleaning or additional checks are identified before approval.',
  },
  '/refrigeration-repairs': {
    label: 'Repair options',
    heading: 'Understand what your equipment needs',
    paragraph: 'We explain the work proposed after assessing your refrigeration unit. Parts, cleaning and further investigation are described separately, so you can review what is included before deciding whether to approve the recommendation.',
    items: SHARED_REFRIGERATION_OPTIONS,
  },
  '/aircons-installations-camps-bay': {
    heading: 'Know the remedy being put forward',
    paragraph: 'We explain the proposed work for your Camps Bay aircon, including its intended scope. You can ask about the recommendation before deciding whether to proceed.',
  },
  '/aircons-installations-meadowridge': {
    heading: 'Separate repair work from maintenance',
    paragraph: 'We discuss the recommendation for your Meadowridge aircon and identify any separate cleaning proposal. You can review each part before deciding what work to approve.',
  },
  '/aircons-installer-ridgewood': {
    heading: 'Understand the recommendation for weaker cooling',
    paragraph: 'We explain the proposed work for your Ridgewood aircon and its scope. You can consider any cleaning, parts or further checks before approving the quote.',
  },
  '/aircons-installations-platterkloof': {
    heading: 'Know what is proposed for recurring trouble',
    paragraph: 'We explain the next work being recommended for your Plattekloof aircon. A defined repair is kept distinct from investigation that has not yet established the remedy.',
  },
  '/aircons-installation-monte-vista': {
    heading: 'Understand the work behind the recommendation',
    paragraph: 'We explain the proposal for your Monte Vista aircon after assessment. You can review what is included and whether further investigation is needed before deciding.',
  },

  // Atlantic Seaboard
  '/aircon-repair-alphen-estate-constantia': {
    heading: 'Know what the proposed work includes',
    paragraph: 'Before agreeing to work on your Alphen Estate aircon, review what is being recommended and why. We explain the proposed repair, cleaning or further investigation.',
  },
  '/aircon-repair-avignon-security-estate-hout-bay': {
    heading: 'A repair recommendation with an explanation',
    paragraph: 'We explain what needs attention at your Avignon Estate property. Any proposed parts, cleaning or refrigerant work are described so you can review the scope.',
  },
  '/aircon-repair-bakoven': {
    heading: 'What work is your aircon being quoted for?',
    paragraph: 'A quote should tell you more than the total. For your Bakoven aircon, we explain the proposed work and distinguish repairs from any separate maintenance recommendation.',
  },
  '/aircon-repair-bantry-bay': {
    heading: 'Understand the remedy before approving it',
    paragraph: 'Your Bantry Bay repair proposal follows the assessment findings. We explain what is being recommended, including whether the next step involves work or further investigation.',
  },
  '/aircon-repair-bergendal-security-estate-hout-bay': {
    heading: 'Choose after the options are explained',
    paragraph: 'We discuss the proposed work for your Bergendal Estate aircon and explain its scope. You can ask questions before deciding whether to approve the recommendation.',
  },
  '/aircon-repair-clifton': {
    heading: 'Compare the proposal with the findings',
    paragraph: 'We explain how the recommended work relates to the assessment of your Clifton aircon. You can review the scope and cost before choosing whether to proceed.',
  },
  '/aircon-repair-fresnaye': {
    heading: 'Review the remedy before authorising work',
    paragraph: 'Your Fresnaye repair proposal explains the work being recommended and why. If the assessment leaves questions unresolved, we discuss the next investigation separately.',
  },
  '/aircon-repair-green-point': {
    heading: 'See what the repair price covers',
    paragraph: 'For your Green Point aircon, we explain the quoted work rather than only presenting a total. Ask about any part of the recommendation before authorising it.',
  },
  '/aircon-repair-hanging-meadows-security-estate-hout-bay': {
    heading: 'Know the work being put forward',
    paragraph: 'We describe the proposal for your Hanging Meadows aircon, including any further investigation. You can review what is defined and what still needs establishing before proceeding.',
  },
  '/aircon-repair-hout-bay': {
    heading: 'Repair, cleaning or replacement discussion?',
    paragraph: 'We explain which next step is being proposed for your Hout Bay aircon and why. You can review the scope before choosing whether to approve the work.',
  },
  '/aircon-repair-kenrock-security-estate-hout-bay': {
    heading: 'Know the reason behind the proposed work',
    paragraph: 'For your KenRock Estate aircon, we explain the recommendation rather than asking you to approve unexplained parts. Any further investigation is identified before additional work is agreed.',
  },
  '/aircon-repair-llandudno': {
    heading: 'Make the decision with the scope explained',
    paragraph: 'We describe the work being recommended for your Llandudno aircon. You can consider the proposal, ask about alternatives and review the cost before approving it.',
  },
  '/aircon-repair-mouille-point': {
    heading: 'Understand the work proposed after the noise check',
    paragraph: 'We explain what is recommended for your Mouille Point aircon and why. If the sound needs further investigation, that is distinguished from a defined repair.',
  },
  '/aircon-repair-ruyteplaats-security-estate-hout-bay': {
    heading: 'See the difference between findings and possibilities',
    paragraph: 'For your Ruyteplaats aircon, we explain whether a repair is defined or further checks are needed. The proposed next work is described before you authorise it.',
  },
  '/aircon-repair-sea-point': {
    heading: 'Understand the repair, not only the total',
    paragraph: 'Your Sea Point proposal describes the recommended work and its purpose. We explain what is included so you can review the scope alongside the quoted cost.',
  },
  '/aircon-repair-stoneybrook-security-estate-hout-bay': {
    heading: 'A clear next step for an occasional fault',
    paragraph: 'We explain what is proposed for your Stoneybrook aircon and distinguish a defined repair from further investigation. You know which work is being considered before approving it.',
  },
  '/aircon-repair-three-anchor-bay': {
    heading: 'Review the remedy alongside the findings',
    paragraph: 'We describe the recommendation for your Three Anchor Bay aircon and what it includes. You can consider the proposed work and quoted cost before authorising it.',
  },
  '/aircon-repair-tierboskloof-security-estate-hout-bay': {
    heading: 'Know what the next proposal covers',
    paragraph: 'We explain whether your Tierboskloof aircon has a defined repair recommendation or needs further investigation. The work being proposed is described before you decide.',
  },

  // City Bowl / CBD
  '/aircon-repair-bo-kaap': {
    heading: 'An explained proposal before the repair',
    paragraph: 'We discuss the findings for your Bo-Kaap aircon and describe the proposed remedy. If the next step is further investigation, we make that clear before seeking approval.',
  },
  '/aircon-repair-devils-peak-estate': {
    heading: 'Know what addresses the reported problem',
    paragraph: "We explain the recommended work for your Devil's Peak Estate aircon and its intended scope. Maintenance recommendations are distinguished from repairs proposed for the complaint.",
  },
  '/aircon-repair-gardens': {
    heading: 'A clear proposal after the checks',
    paragraph: 'We describe the next step for your Gardens aircon, whether it is defined repair work or further investigation. You know which is being quoted before deciding.',
  },
  '/aircon-repair-higgovale': {
    heading: 'Move from restarting to an explained proposal',
    paragraph: 'We discuss the work recommended after assessing your Higgovale aircon. Any repair or additional investigation is described so you can decide on the next step.',
  },
  '/aircon-repair-oranjezicht': {
    heading: 'Understand the proposal behind the price',
    paragraph: 'We explain the remedy being proposed for your Oranjezicht aircon. Any separate maintenance or additional checks are identified so you know what you are being asked to approve.',
  },
  '/aircon-repair-tamboerskloof': {
    heading: 'Know what is recommended after the change',
    paragraph: 'We explain the proposed work for your Tamboerskloof aircon and its scope. If the next step is further investigation rather than repair, that distinction is made clear.',
  },
  '/aircon-repair-v-a-waterfront': {
    heading: 'Understand the repair before planning around it',
    paragraph: 'We describe the proposed work at your V&A Waterfront property so you can review the scope and cost before discussing arrangements and authorising the repair.',
  },
  '/aircon-repair-vredehoek': {
    heading: 'Review the next step for changing symptoms',
    paragraph: 'We explain what is proposed for your Vredehoek aircon and whether the repair is defined. Unresolved questions and further investigation are discussed separately from confirmed work.',
  },

  // Southern Suburbs / Constantia Valley
  '/aircon-repair-bergvliet': {
    heading: 'Parts, cleaning — or another next step?',
    paragraph: 'We explain what the assessment supports for your Bergvliet aircon. The proposal distinguishes component repairs from cleaning and any checks still needed before work can be defined.',
  },
  '/aircon-repair-bishopscourt': {
    heading: 'Know what each affected unit needs',
    paragraph: 'If several aircons need attention at your Bishopscourt property, we explain the proposal for each. The work is described without assuming every unit needs the same treatment.',
  },
  '/aircon-repair-claremont': {
    heading: 'Know why a part is being proposed',
    paragraph: 'If a replacement component is recommended for your Claremont aircon, we explain the reason. Cleaning or further testing is described separately where it forms part of the proposal.',
  },
  '/aircon-repair-constantia': {
    heading: 'Repair work, explained before approval',
    paragraph: 'Your Constantia aircon may be quoted for parts, cleaning or other work following assessment. We explain what is proposed rather than leaving you to interpret the quote alone.',
  },
  '/aircon-repair-dreyersdal-bergvliet-area': {
    heading: 'Repair options without the unfamiliar jargon',
    paragraph: 'For your Dreyersdal aircon, we describe what is being proposed in everyday language. You can ask about the parts, work and cost before deciding.',
  },
  '/aircon-repair-high-constantia-security-estate': {
    heading: 'Understand what is being recommended',
    paragraph: 'Your High Constantia proposal explains the work being put forward following assessment. Parts, cleaning and additional investigation are identified where they form part of the recommendation.',
  },
  '/aircon-repair-kenilworth': {
    heading: 'An explained remedy for the assessed problem',
    paragraph: 'We describe what is being recommended for your Kenilworth aircon and its intended scope. You can ask questions about the proposal before deciding whether to proceed.',
  },
  '/aircon-repair-kirstenhof': {
    heading: 'Review the next step for the fault',
    paragraph: 'We explain whether the Kirstenhof assessment supports a repair proposal or further investigation. The work being quoted is described before you make a decision.',
  },
  '/aircon-repair-marina-da-gama-muizenberg': {
    heading: 'Match the proposed remedy to the assessment',
    paragraph: 'We describe the work recommended for your Marina da Gama aircon after assessment. Any additional maintenance or further investigation is explained separately from the proposed repair.',
  },
  '/aircon-repair-newlands': {
    heading: 'Know what the recommendation covers',
    paragraph: 'We describe the work proposed for your Newlands aircon, including any parts or cleaning. You can review what is included rather than relying on the quote total alone.',
  },
  '/aircon-repair-rondebosch': {
    heading: 'Know what the repair is intended to address',
    paragraph: 'We explain the proposed work for your Rondebosch aircon and how it relates to the assessed complaint. Additional maintenance recommendations are described separately.',
  },
  '/aircon-repair-rondebosch-oval-estate': {
    heading: 'Parts and labour, explained before approval',
    paragraph: 'We discuss the work being proposed for your aircon at Rondebosch Oval. You can review the recommendation and ask what is included before approving repairs.',
  },
  '/aircon-repair-silverhurst-security-estate-constantia': {
    heading: 'A clear account of the recommended work',
    paragraph: 'We explain the proposal for your Silverhurst aircon, including any separate cleaning or additional checks. You can ask questions before deciding whether to approve the work.',
  },
  '/aircon-repair-silvertree-estate-tokai': {
    heading: 'Know which work addresses the complaint',
    paragraph: 'We describe the proposed repair for your Silvertree Estate aircon. Any maintenance recommendation is distinguished from the work intended to address the reported problem.',
  },
  '/aircon-repair-steenberg': {
    heading: 'Clear repair options without the jargon',
    paragraph: 'We explain what is being recommended for your Steenberg aircon in everyday language. You can ask about the parts, cleaning or further checks before deciding on the work.',
  },
  '/aircon-repair-stonehurst-security-estate-tokai': {
    heading: 'Know the scope before making the commitment',
    paragraph: 'Your Stonehurst repair proposal explains what is recommended and included. You can review the work and ask questions before deciding whether to proceed with the quote.',
  },
  '/aircon-repair-tokai': {
    heading: 'Choose after the work is explained',
    paragraph: 'We discuss the recommendation for your Tokai aircon, including any parts, cleaning or further checks. You can review the scope before agreeing to the proposed work.',
  },
  '/aircon-repair-zwaanswyk': {
    heading: 'Know what you are being quoted for',
    paragraph: 'We explain the proposed remedy for your Zwaanswyk aircon and its scope. You can review what is included and ask questions before making the repair decision.',
  },

  // Peninsula / False Bay
  '/aircon-repair-capri-village-fish-hoek': {
    heading: 'A defined repair — or a clear next check',
    paragraph: 'If your Capri Village fault comes and goes, the next step may need discussion. We distinguish a proposed repair from investigation that has not yet established the remedy.',
  },
  '/aircon-repair-clovelly': {
    heading: 'Understand the next step before spending',
    paragraph: 'We explain whether your Clovelly aircon has a defined repair proposal or needs further investigation. Any work being quoted is described before you approve it.',
  },
  '/aircon-repair-de-goede-hoop-security-estate-noordhoek': {
    heading: 'A clear scope for the work proposed',
    paragraph: 'We describe the recommendation for your De Goede Hoop aircon, including any separate cleaning or further investigation. You can review the work before deciding whether to authorise it.',
  },
  '/aircon-repair-glencairn': {
    heading: 'Know whether it is a repair or another check',
    paragraph: 'An occasional fault may leave unanswered questions. For your Glencairn aircon, we explain what has been established and exactly what work is being proposed next.',
  },
  '/aircon-repair-kalk-bay': {
    heading: 'Understand what is included — and what is separate',
    paragraph: 'We explain the recommendation for your Kalk Bay aircon, distinguishing repair work from any cleaning or additional checks. You can then consider each part of the proposal.',
  },
  '/aircon-repair-lake-michelle-security-lifestyle-estate-noordhoek': {
    heading: 'Know what is defined and what remains open',
    paragraph: 'If your Lake Michelle aircon needs further investigation, we explain that distinction. A proposed repair is not presented as established work when questions remain unresolved.',
  },
  '/aircon-repair-muizenberg': {
    heading: 'Review your options before spending',
    paragraph: 'Your Muizenberg repair proposal explains the recommended work and its scope. You can ask about the reasoning and consider the cost before making a decision.',
  },
  '/aircon-repair-noordhoek': {
    heading: 'An explained next step for your aircon',
    paragraph: 'We discuss what is being recommended for your Noordhoek unit and distinguish defined repairs from further investigation. You decide after reviewing the proposed work and cost.',
  },
  '/aircon-repair-plumstead': {
    heading: 'Review the work before changing more settings',
    paragraph: 'We describe the recommendation following your Plumstead assessment, including its scope. You can consider the work and cost before deciding whether to approve the proposal.',
  },
  '/aircon-repair-scarborough': {
    heading: 'Know the proposed response to unreliable operation',
    paragraph: 'We explain what is being recommended for your Scarborough aircon. You can review whether the proposal covers repairs, maintenance or further investigation before making a decision.',
  },
  '/aircon-repair-st-james': {
    heading: 'A remedy explained before you agree',
    paragraph: 'Your St James proposal sets out the recommended work following assessment. We discuss the scope so you can consider the repair and cost with the relevant details.',
  },

  // Century City
  '/aircon-repair-century-city': {
    heading: 'Know the scope before making arrangements',
    paragraph: 'We explain the proposed work for your Century City aircon, including whether it involves parts, cleaning or further checks. You can then discuss practical arrangements with the scope in mind.',
  },
  '/aircon-repair-island-club-century-city': {
    heading: 'Know the repair before planning access',
    paragraph: 'We describe the proposed work on your Island Club aircon so you can review the quote and discuss any access arrangements with the scope understood.',
  },
  '/aircon-repair-knightsbridge-century-city': {
    heading: 'Understand the proposed work before booking it',
    paragraph: 'We describe the repair recommendation for your Knightsbridge aircon and what it includes. You can review the quote and ask questions before agreeing on the work.',
  },

  // Northern Suburbs
  '/aircon-repair-big-bay': {
    heading: 'Review the work, not just the price',
    paragraph: 'For your Big Bay aircon, we describe the proposed remedy and what is included. You can consider the explanation alongside the quote before deciding.',
  },
  '/aircon-repair-bloubergstrand': {
    heading: 'Match the work to the findings',
    paragraph: 'We explain the work being recommended for your Bloubergstrand aircon. Any proposed cleaning, parts or refrigerant work is identified so you know what you are considering.',
  },
  '/aircon-repair-burgundy-estate': {
    heading: 'Understand what you are agreeing to',
    paragraph: 'Your Burgundy Estate repair proposal sets out the work being recommended. We explain the scope and answer questions before you decide whether to authorise it.',
  },
  '/aircon-repair-clara-anna-fontein-durbanville': {
    heading: 'See what is included in the recommendation',
    paragraph: 'For your Clara Anna Fontein aircon, we describe the work supported by the assessment. Any additional maintenance proposal is explained separately from the reported fault.',
  },
  '/aircon-repair-edgemead': {
    heading: 'A replacement part needs an explanation',
    paragraph: 'If your Edgemead aircon is quoted for a new component, we explain the recommendation. The proposed work is set out for you to review before approval.',
  },
  '/aircon-repair-graanendal-lifestyle-estate-durbanville': {
    heading: 'Separate the repair from extra maintenance',
    paragraph: 'We explain the work proposed for your Graanendal aircon. If cleaning or other maintenance is also recommended, it is described separately so the choices are clear.',
  },
  '/aircon-repair-loevenstein': {
    heading: 'Separate cleaning from component repairs',
    paragraph: 'We explain the proposal for your Loevenstein aircon and distinguish any cleaning from parts replacement. Where both are recommended, you can see what each part involves.',
  },
  '/aircon-repair-parklands': {
    heading: 'A defined proposal for the stopping complaint',
    paragraph: 'We explain the recommendation for your Parklands aircon and what supports it. Further investigation is kept distinct from repair work that is ready to quote.',
  },
  '/aircon-repair-sonstraal-durbanville': {
    heading: 'Understand the proposed work for weaker cooling',
    paragraph: 'We discuss the recommendation for your Sonstraal aircon after assessment. You can see whether the proposal involves cleaning, components or further checks before agreeing to proceed.',
  },
  '/aircon-repair-sonstraal-heights-durbanville': {
    heading: 'Know the next work being recommended',
    paragraph: 'We explain the proposal for your Sonstraal Heights aircon and what is included. If the fault needs more investigation, that is described before additional work is authorised.',
  },
  '/aircon-repair-sunningdale': {
    heading: 'Understand the proposed remedy for the cooling complaint',
    paragraph: 'We describe the recommendation for your Sunningdale aircon after assessment. You can review the work and cost, including any separate cleaning proposal, before making a decision.',
  },
  '/aircon-repair-welgemoed': {
    heading: 'Understand the proposed work before spending',
    paragraph: 'We describe the recommendation for your Welgemoed aircon after assessment. The proposal distinguishes repair work from any maintenance or further checks so you can consider each part.',
  },

  // Helderberg
  '/aircon-repair-de-zalze-golf-estate-somerset-west-stellenbosch-border': {
    heading: 'Consider the recommendation before committing',
    paragraph: 'We explain the proposal for your De Zalze aircon and the reasoning behind it. Where replacement is worth considering, that discussion is kept separate from approval of repairs.',
  },
  '/aircon-repair-erinvale-golf-estate-somerset-west': {
    heading: 'Understand the work behind the quote',
    paragraph: 'We describe the proposed remedy for your Erinvale aircon, including any parts or cleaning. You can review what is included before agreeing to proceed.',
  },
  '/aircon-repair-gordons-bay': {
    heading: 'Understand the proposed route to repair',
    paragraph: "We discuss the recommendation for your Gordon's Bay aircon and describe its scope. You can consider the work and cost together before giving approval.",
  },
  '/aircon-repair-somerset-west': {
    heading: 'Consider the work supported by the assessment',
    paragraph: 'We explain the proposal for your Somerset West aircon and describe its scope. Repair, maintenance and further investigation are kept distinct so you can review the recommendation.',
  },

  // Cape Winelands
  '/aircon-repair-franschhoek': {
    heading: 'Know what is recommended for the cooling complaint',
    paragraph: 'We explain the proposal following your Franschhoek assessment. Cleaning, component work and further investigation are distinguished rather than presented as interchangeable solutions.',
  },
  '/aircon-repair-paarl': {
    heading: 'Know what follows from the findings',
    paragraph: 'We describe the proposed work for your Paarl aircon after assessment. If more investigation is needed before a repair can be defined, we explain that next step.',
  },
  '/aircon-repair-stellenbosch': {
    heading: 'Review what the quote is asking you to approve',
    paragraph: 'We describe the proposed work for your Stellenbosch aircon and the reason for it. Any separate maintenance or investigation is identified before you authorise repairs.',
  },
  '/aircon-repair-val-de-vie-estate-paarl': {
    heading: 'Know what is included in the proposal',
    paragraph: 'We explain the work being recommended for your Val de Vie aircon. Any separate maintenance or further investigation is identified before you decide whether to approve repairs.',
  },
};

for (const [route, options] of Object.entries(LOCATION_OPTIONS)) {
  if (LOCATION_PAGES[route]) {
    LOCATION_PAGES[route].options = {
      label: options.label ?? 'Repair options',
      heading: options.heading,
      intro: options.paragraph,
      items: options.items ?? SHARED_AIRCON_OPTIONS,
    };
  }
}

// Contact block (Cta25) + enquiry form (BookingForm) + FAQ content is
// generated from each page's suburb — the supplied {Location} template.
const AIRCON_CONTACT_PARAGRAPH =
  "Call or send a WhatsApp message with your area, the unit's make and what's happening. Ask about arranging an assessment and any charges before booking.";

const AIRCON_PROBLEM_OPTIONS = [
  'Not cooling properly',
  'Leaking water indoors',
  'Making an unfamiliar noise',
  "Won't switch on",
  'Keeps starting and stopping',
  'Another problem',
  'Not sure how to describe it',
];

const REFRIGERATION_PROBLEM_OPTIONS = [
  'Not keeping cold',
  'Water inside or around the unit',
  'Making an unfamiliar noise',
  "Won't switch on",
  'Temperature keeps changing',
  'Another problem',
  'Not sure how to describe it',
];

const AIRCON_FORM_OVERRIDES = {
  eyebrow: 'Repair enquiry',
  title: 'Tell us what your aircon is doing',
  contactPrompt: 'Prefer to explain it over the phone?',
  submitLabel: 'Send repair enquiry',
  disclaimer: 'Submitting this form does not confirm an appointment. Please ask about availability and any call-out or assessment charges.',
  errorMessage: 'Your enquiry could not be sent. Please try again or contact us by phone.',
  nameLabel: 'Your name',
  namePlaceholder: 'Name and surname',
  phoneLabel: 'Contact number',
  phonePlaceholder: 'Your phone number',
  emailLabel: 'Email address',
  emailPlaceholder: 'Your email address',
  areaLabel: 'Area or suburb',
  areaPlaceholder: 'Enter your suburb or estate',
  problemLabel: 'What is the main problem?',
  problemPlaceholder: 'Select a problem',
  problemOptions: AIRCON_PROBLEM_OPTIONS,
  extraField: {
    type: 'select',
    label: 'When did you first notice it?',
    options: [
      'Today',
      'Within the past few days',
      'Within the past few weeks',
      'Longer than a month',
      'It happens occasionally',
      'Not sure',
    ],
  },
  extraPlaceholder: 'Select an option',
  urgencyLabel: 'When would you like a visit?',
  urgencyPlaceholder: 'Select a preference',
  urgencyOptions: [
    'As soon as a slot is available',
    'Within the next few days',
    'Next week',
    'I have a particular date in mind',
    "I'm flexible",
  ],
  timeLabel: 'Preferred time of day',
  timePlaceholder: 'Select a preference',
  timeOptions: ['Morning', 'Afternoon', 'No preference', 'Please contact me to discuss'],
  messageLabel: 'Tell us more about the unit',
  messagePlaceholder: 'Include the make, model if known, symptoms and any display message.',
};

const REFRIGERATION_FORM_OVERRIDES = {
  ...AIRCON_FORM_OVERRIDES,
  eyebrow: 'Refrigeration enquiry',
  title: 'Tell us about the equipment and the problem',
  submitLabel: 'Send refrigeration enquiry',
  disclaimer: 'Submitting this form does not confirm an appointment. Please ask about equipment coverage, availability and any assessment charges.',
  problemOptions: REFRIGERATION_PROBLEM_OPTIONS,
  messagePlaceholder: 'Include the equipment type, make and model if known, symptoms and any displayed message.',
};

const buildAirconFaqs = (location) => [
  {
    question: `Can I enquire about an aircon repair in ${location}?`,
    answer: "Yes — send your suburb or estate, the unit's make and a description of the problem. Ask us to confirm coverage, availability and any visit charges for your address before booking.",
  },
  {
    question: 'Can you tell what is wrong from a message?',
    answer: 'A description, photo or display message gives us a starting point. We may still need to assess the unit before defining a repair and providing a quote.',
  },
  {
    question: 'What should I send with my enquiry?',
    answer: 'Include your area, the make and model if known, what the unit is doing and when the problem began. Mention any displayed message or previous work relating to the complaint.',
  },
  {
    question: 'Will I see the repair quote before work begins?',
    answer: 'We explain the proposed repair and provide a written quote for approval before repairs start. Ask separately about any call-out, inspection or diagnostic charges when arranging the visit.',
  },
  {
    question: 'Will the repair be completed during the first visit?',
    answer: 'Please ask when booking. We do not promise completion during the first visit; the proposed work and arrangements are discussed after the assessment.',
  },
  {
    question: "What if I'm unsure whether to repair or replace it?",
    answer: 'Ask us to explain the repair proposal and why replacement might be worth considering. You can review the available information before choosing which option to pursue.',
  },
];

const REFRIGERATION_FAQS = [
  {
    question: 'Can I enquire about refrigeration repairs in Cape Town?',
    answer: 'Send your area, equipment type, make and a description of the problem. Ask us to confirm whether the equipment and address are covered before booking.',
  },
  {
    question: 'What equipment details should I provide?',
    answer: 'Tell us whether it is a fridge, freezer or another refrigeration unit. Include the make, model if known, symptoms and any displayed temperature or message.',
  },
  {
    question: 'Can you quote from a photo?',
    answer: 'Photos can help explain the equipment and complaint, but an assessment may still be needed before a repair can be defined and quoted.',
  },
  {
    question: 'Will I approve the repair first?',
    answer: 'We explain the proposed repair and provide a written quote for approval before repairs begin. Ask separately about any call-out or assessment charges.',
  },
  {
    question: 'Can you complete the work during the first visit?',
    answer: 'Please discuss this when booking. Completion during the first visit is not promised; the proposed repair and arrangements are explained after assessment.',
  },
  {
    question: "What if I'm considering replacement?",
    answer: 'Ask for an explanation of the repair proposal and why replacement may be worth considering. Review the available information before deciding which option to pursue.',
  },
];

// Attach contact / form / FAQ content to every mapped location page.
for (const [route, page] of Object.entries(LOCATION_PAGES)) {
  const location = page.suburb ?? 'Cape Town';
  if (route === '/refrigeration-repairs') {
    page.contact = {
      heading: 'Need help with refrigeration equipment?',
      paragraph: 'Tell us what type of equipment you have, where it is and what has changed. Ask about arranging an assessment in Cape Town and any charges before booking.',
    };
    page.banner = {
      label: "Tell us what's happening",
      heading: 'Need help with refrigeration equipment?',
      button: 'Send a refrigeration enquiry',
      href: '#booking-form',
    };
    page.form = {
      ...REFRIGERATION_FORM_OVERRIDES,
      subtitle: 'Share your Cape Town area, equipment details and symptoms so we can discuss whether an assessment can be arranged.',
    };
    page.faqs = { heading: 'Questions before arranging an assessment', items: REFRIGERATION_FAQS };
  } else {
    // Approved short display name for long estate names in the banner;
    // the full location stays in the page copy.
    const bannerLocation =
      route === '/aircon-repair-clara-anna-fontein-durbanville'
        ? 'Clara Anna Fontein'
        : location;
    page.contact = {
      heading: `Need aircon help in ${location}?`,
      paragraph: AIRCON_CONTACT_PARAGRAPH,
    };
    page.banner = {
      label: "Let's discuss the problem",
      heading: `Need aircon help in ${bannerLocation}?`,
      button: 'Enquire about a repair',
      href: '#booking-form',
    };
    page.form = {
      ...AIRCON_FORM_OVERRIDES,
      subtitle: `Enquiring about a unit in ${location}? Share the symptoms and your contact details so we can discuss an assessment.`,
    };
    page.faqs = { heading: 'Questions before arranging a repair', items: buildAirconFaqs(location) };
  }
}

export const LOCATION_ROUTES = Object.keys(LOCATION_PAGES);
